/* eslint-disable max-len */
export const DashboardIcon = (props: any) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} {...props}>
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.56}
        d="M5.072 11a2.19 2.19 0 0 1-1.607-.668 2.19 2.19 0 0 1-.668-1.607V5.072c0-.626.222-1.161.668-1.607a2.19 2.19 0 0 1 1.607-.668h3.653a2.19 2.19 0 0 1 1.607.668c.445.446.668.981.668 1.607v3.653a2.19 2.19 0 0 1-.668 1.607A2.19 2.19 0 0 1 8.725 11H5.072Zm0 10.203a2.19 2.19 0 0 1-1.607-.668 2.19 2.19 0 0 1-.668-1.607v-3.653c0-.626.222-1.161.668-1.607A2.19 2.19 0 0 1 5.072 13h3.653a2.19 2.19 0 0 1 1.607.668c.445.446.668.981.668 1.607v3.653a2.19 2.19 0 0 1-.668 1.607 2.19 2.19 0 0 1-1.607.668H5.072ZM15.275 11a2.19 2.19 0 0 1-1.607-.668A2.19 2.19 0 0 1 13 8.725V5.072c0-.626.223-1.161.668-1.607a2.19 2.19 0 0 1 1.607-.668h3.653a2.19 2.19 0 0 1 1.607.668c.445.446.668.981.668 1.607v3.653a2.19 2.19 0 0 1-.668 1.607 2.19 2.19 0 0 1-1.607.668h-3.653Zm0 10.203a2.19 2.19 0 0 1-1.607-.668A2.19 2.19 0 0 1 13 18.928v-3.653c0-.626.223-1.161.668-1.607A2.19 2.19 0 0 1 15.275 13h3.653a2.19 2.19 0 0 1 1.607.668c.445.446.668.981.668 1.607v3.653a2.19 2.19 0 0 1-.668 1.607 2.19 2.19 0 0 1-1.607.668h-3.653ZM5.072 8.725h3.653V5.072H5.072v3.653Zm10.203 0h3.653V5.072h-3.653v3.653Zm0 10.203h3.653v-3.653h-3.653v3.653Zm-10.203 0h3.653v-3.653H5.072v3.653Z"
      />
    </g>
  </svg>
);

export const ScheduleIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.56}
        d="M8.048 14.054c-.297 0-.546-.1-.747-.3-.2-.2-.301-.447-.301-.742s.1-.544.301-.745c.201-.202.45-.303.747-.303h7.904c.297 0 .546.1.747.301.2.201.3.45.3.747 0 .295-.1.543-.3.742-.201.2-.45.3-.747.3H8.048Zm0 3.982c-.297 0-.546-.1-.747-.301-.2-.201-.301-.45-.301-.747 0-.295.1-.543.301-.742.201-.2.45-.3.747-.3h4.904c.297 0 .546.1.747.3.2.2.3.447.3.742s-.1.544-.3.745c-.201.202-.45.303-.747.303H8.048Zm-2.976 4.167c-.63 0-1.167-.221-1.61-.665a2.192 2.192 0 0 1-.665-1.61V6.072c0-.63.221-1.167.665-1.61.443-.444.98-.665 1.61-.665H6v-.929c0-.299.104-.552.311-.76.208-.207.461-.311.76-.311.3 0 .552.104.758.311.206.208.308.461.308.76v.929h7.725v-.929c0-.299.104-.552.312-.76.207-.207.46-.311.76-.311s.552.104.758.311c.205.208.308.461.308.76v.929h.928c.63 0 1.166.221 1.61.665.443.443.665.98.665 1.61v13.856c0 .63-.222 1.167-.665 1.61-.444.444-.98.665-1.61.665H5.072Zm0-2.275h13.856V10H5.072v9.928ZM5.072 8h13.856V6.072H5.072V8Z"
      />
    </g>
  </svg>
);

export const UsersIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.56}
        d="M1.952 20.305c-.319 0-.588-.11-.808-.33-.22-.219-.33-.488-.33-.808V17.29c0-.604.157-1.159.47-1.665a3.117 3.117 0 0 1 1.244-1.159 15.15 15.15 0 0 1 3.192-1.174 14.108 14.108 0 0 1 6.608-.003c1.082.26 2.142.65 3.18 1.171.517.266.932.651 1.245 1.156.312.505.468 1.063.468 1.674v1.877c0 .32-.11.589-.33.808-.219.22-.488.33-.807.33H1.952Zm16.818 0c.166-.133.298-.298.395-.497.097-.198.146-.42.146-.666v-2.034c0-.75-.202-1.472-.607-2.167-.404-.695-.987-1.314-1.75-1.857a12.743 12.743 0 0 1 4.316 1.376c.616.334 1.089.727 1.42 1.18.33.454.495.949.495 1.485v2.042c0 .32-.11.589-.329.808-.22.22-.489.33-.808.33H18.77Zm-9.752-8.407c-1.132 0-2.099-.4-2.9-1.201-.801-.802-1.202-1.768-1.202-2.9s.401-2.099 1.202-2.9c.801-.801 1.768-1.202 2.9-1.202s2.098.4 2.9 1.202c.801.801 1.202 1.768 1.202 2.9s-.401 2.098-1.202 2.9c-.802.8-1.768 1.201-2.9 1.201ZM19.31 7.797c0 1.128-.402 2.093-1.205 2.897-.803.803-1.768 1.204-2.896 1.204a4.69 4.69 0 0 1-.7-.065 5.834 5.834 0 0 1-.719-.153 5.982 5.982 0 0 0 1.418-3.883 5.99 5.99 0 0 0-1.418-3.884c.238-.087.473-.145.706-.174.234-.03.47-.044.71-.044 1.128 0 2.094.402 2.898 1.205.804.803 1.206 1.769 1.206 2.897ZM3.09 18.03h11.856v-.71a.906.906 0 0 0-.137-.49.964.964 0 0 0-.363-.342 12.904 12.904 0 0 0-2.671-.983 11.577 11.577 0 0 0-2.757-.332c-.925 0-1.844.11-2.757.332-.913.22-1.803.548-2.671.982a.965.965 0 0 0-.363.343.906.906 0 0 0-.137.49v.71Zm5.927-8.317c.527 0 .978-.188 1.354-.563.375-.375.563-.826.563-1.352 0-.527-.187-.978-.562-1.354a1.843 1.843 0 0 0-1.353-.564c-.527 0-.978.188-1.354.563a1.843 1.843 0 0 0-.563 1.353c0 .527.187.978.562 1.353.375.376.826.564 1.353.564Z"
      />
    </g>
  </svg>
);

export const ChargeIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.56}
        d="M10 16h1c0 .283.096.52.287.712.192.192.43.288.713.288s.52-.096.712-.288A.968.968 0 0 0 13 16h1c.283 0 .52-.096.712-.287A.968.968 0 0 0 15 15v-3a.968.968 0 0 0-.288-.713A.968.968 0 0 0 14 11h-3v-1h3c.283 0 .52-.096.712-.287A.968.968 0 0 0 15 9a.968.968 0 0 0-.288-.713A.968.968 0 0 0 14 8h-1a.968.968 0 0 0-.288-.713A.968.968 0 0 0 12 7a.967.967 0 0 0-.713.287A.967.967 0 0 0 11 8h-1a.968.968 0 0 0-.713.287A.968.968 0 0 0 9 9v3c0 .283.096.52.287.713.192.191.43.287.713.287h3v1h-3a.967.967 0 0 0-.713.287A.968.968 0 0 0 9 15c0 .283.096.52.287.713.192.191.43.287.713.287Zm-5.928 4.203c-.63 0-1.167-.221-1.61-.665a2.193 2.193 0 0 1-.665-1.61V6.072c0-.63.221-1.167.665-1.61.443-.444.98-.665 1.61-.665h15.856c.63 0 1.166.221 1.61.665.443.443.665.98.665 1.61v11.856c0 .63-.222 1.167-.665 1.61-.444.444-.98.665-1.61.665H4.072Zm0-2.275h15.856V6.072H4.072v11.856Z"
      />
    </g>
  </svg>
);

export const StaffIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.56}
        d="M9.03 14.268c-.358 0-.659-.122-.903-.366A1.226 1.226 0 0 1 7.762 13c0-.358.122-.659.365-.902.244-.244.545-.366.903-.366s.659.122.902.366c.244.243.366.544.366.902s-.122.659-.366.902a1.226 1.226 0 0 1-.902.366Zm5.94 0c-.358 0-.659-.122-.902-.366a1.226 1.226 0 0 1-.366-.902c0-.358.122-.659.366-.902.243-.244.544-.366.902-.366s.659.122.903.366c.243.243.365.544.365.902s-.122.659-.365.902a1.226 1.226 0 0 1-.903.366ZM12 19.928c2.21 0 4.084-.767 5.624-2.3 1.54-1.534 2.31-3.406 2.31-5.616 0-.4-.025-.785-.075-1.154a4.74 4.74 0 0 0-.275-1.072 9.074 9.074 0 0 1-2.132.25 9.689 9.689 0 0 1-4.261-.966 9.947 9.947 0 0 1-3.423-2.704 9.698 9.698 0 0 1-2.264 3.348 9.8 9.8 0 0 1-3.426 2.148v.15c0 2.21.768 4.082 2.304 5.616 1.536 1.533 3.409 2.3 5.618 2.3Zm.006 2.275a9.939 9.939 0 0 1-3.977-.802 10.302 10.302 0 0 1-3.241-2.183 10.3 10.3 0 0 1-2.183-3.24 9.94 9.94 0 0 1-.802-3.979c0-1.41.267-2.736.802-3.977a10.302 10.302 0 0 1 2.183-3.24c.92-.92 2-1.648 3.24-2.183a9.94 9.94 0 0 1 3.979-.802c1.41 0 2.735.267 3.974.802a10.31 10.31 0 0 1 3.237 2.183c.92.92 1.648 2 2.183 3.24a9.939 9.939 0 0 1 .802 3.979c0 1.41-.267 2.736-.802 3.977a10.301 10.301 0 0 1-2.183 3.24c-.92.92-2 1.648-3.239 2.183a9.92 9.92 0 0 1-3.973.802ZM10.65 4.125a8.016 8.016 0 0 0 2.85 2.813C14.7 7.646 16.033 8 17.5 8c.233 0 .458-.012.675-.037.217-.025.442-.055.675-.088A8.016 8.016 0 0 0 16 5.063C14.8 4.354 13.467 4 12 4a5.89 5.89 0 0 0-.675.038c-.217.025-.442.054-.675.087Zm-6.225 5.35A7.988 7.988 0 0 0 6.65 7.6a7.96 7.96 0 0 0 1.425-2.575A7.987 7.987 0 0 0 5.85 6.9a7.96 7.96 0 0 0-1.425 2.575Z"
      />
    </g>
  </svg>
);

export const ReportingIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.56}
        d="M9.048 18.018h5.91c.295 0 .543-.1.742-.301.2-.201.3-.45.3-.747 0-.295-.1-.543-.3-.742-.2-.2-.447-.3-.742-.3H9.042c-.295 0-.543.1-.743.3-.2.2-.3.447-.3.742 0 .296.101.544.302.745.201.202.45.303.747.303Zm0-4h5.91c.295 0 .543-.1.742-.301.2-.201.3-.45.3-.747 0-.295-.1-.543-.3-.742-.2-.2-.447-.3-.742-.3H9.042c-.295 0-.543.1-.743.3-.2.2-.3.447-.3.742s.101.544.302.745c.201.202.45.303.747.303Zm-2.976 8.185c-.63 0-1.167-.221-1.61-.665a2.193 2.193 0 0 1-.665-1.61V4.072c0-.63.221-1.167.665-1.61.443-.444.98-.665 1.61-.665h7.073a2.246 2.246 0 0 1 1.597.658l4.802 4.803a2.23 2.23 0 0 1 .66 1.597v11.073c0 .63-.223 1.167-.666 1.61-.444.444-.98.665-1.61.665H6.072Zm6.856-14.269V4.072H6.072v15.856h11.856V9.072h-3.862c-.32 0-.589-.11-.809-.33-.22-.22-.329-.489-.329-.808Z"
      />
    </g>
  </svg>
);

export const SettingsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.56}
        d="M13.923 22.203h-3.846a1.08 1.08 0 0 1-.742-.286 1.12 1.12 0 0 1-.376-.708l-.294-2.271a3.296 3.296 0 0 1-.526-.259 8.08 8.08 0 0 1-.488-.32l-2.121.881c-.27.1-.536.109-.802.028a1.07 1.07 0 0 1-.621-.494l-1.91-3.326a1.091 1.091 0 0 1-.14-.799 1.08 1.08 0 0 1 .426-.68l1.827-1.39a2.32 2.32 0 0 1-.02-.29v-.579c0-.092.007-.189.02-.29l-1.827-1.388a1.105 1.105 0 0 1-.426-.687 1.073 1.073 0 0 1 .14-.793l1.91-3.326a.956.956 0 0 1 .615-.498c.273-.074.543-.061.808.038l2.133.882c.16-.114.323-.22.491-.318a4.14 4.14 0 0 1 .51-.256l.295-2.283c.037-.286.161-.523.373-.711.21-.189.46-.283.745-.283h3.846c.286 0 .534.094.745.283.212.188.336.425.373.711l.294 2.283c.185.072.36.157.526.256.166.098.328.204.488.318l2.121-.882c.265-.1.532-.109.799-.028.267.08.475.243.625.488l1.915 3.326c.15.249.196.515.14.799-.056.284-.2.51-.432.68l-1.833 1.39c.013.1.02.197.02.29V12c0 .1-.002.197-.004.29a1.3 1.3 0 0 1-.04.29l1.832 1.389c.228.17.37.396.426.68.056.284.01.55-.14.799l-1.915 3.308a1.11 1.11 0 0 1-.632.503c-.271.087-.542.08-.81-.019l-2.084-.882c-.16.114-.323.22-.491.321-.168.101-.338.187-.51.259l-.295 2.27a1.125 1.125 0 0 1-.373.71c-.21.19-.46.285-.745.285Zm-1.89-6.703c.966 0 1.79-.342 2.474-1.025A3.372 3.372 0 0 0 15.532 12c0-.967-.341-1.792-1.025-2.475A3.372 3.372 0 0 0 12.032 8.5c-.98 0-1.807.342-2.484 1.025A3.388 3.388 0 0 0 8.532 12c0 .967.339 1.792 1.016 2.475s1.505 1.025 2.484 1.025Zm0-2c-.417 0-.772-.146-1.063-.438A1.447 1.447 0 0 1 10.532 12c0-.417.146-.77.438-1.063a1.447 1.447 0 0 1 1.062-.437c.417 0 .771.146 1.063.438.291.291.437.645.437 1.062 0 .417-.146.77-.437 1.063a1.446 1.446 0 0 1-1.063.437Zm-.967 6.428h1.837l.356-2.638a5.775 5.775 0 0 0 1.459-.59c.451-.26.86-.582 1.227-.965l2.47 1.025.902-1.592-2.132-1.613a4.07 4.07 0 0 0 .181-.755 5.672 5.672 0 0 0 0-1.6 4.07 4.07 0 0 0-.18-.755l2.143-1.613-.915-1.592-2.463 1.05a5.363 5.363 0 0 0-2.692-1.58l-.325-2.638h-1.85l-.337 2.632a5.51 5.51 0 0 0-1.474.59 5.733 5.733 0 0 0-1.236.97L5.58 7.24l-.91 1.592 2.127 1.582a4.72 4.72 0 0 0-.181.771A5.651 5.651 0 0 0 6.56 12c0 .27.018.535.056.793.037.258.097.516.18.774l-2.125 1.601.909 1.592 2.457-1.044c.37.392.784.72 1.24.984.455.264.945.463 1.47.596l.319 2.632Z"
      />
    </g>
  </svg>
);

export const ReportIcon = (props: any) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3228_697"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3228_697)">
      <path
        d="M9.04798 18.018H14.9583C15.2535 18.018 15.5009 17.9175 15.7006 17.7167C15.9003 17.5159 16.0001 17.267 16.0001 16.9701C16.0001 16.6749 15.9003 16.4275 15.7006 16.2278C15.5009 16.0281 15.2535 15.9283 14.9583 15.9283H9.042C8.74682 15.9283 8.49937 16.0281 8.29967 16.2279C8.09999 16.4276 8.00015 16.675 8.00015 16.9702C8.00015 17.2655 8.10057 17.5139 8.3014 17.7155C8.50223 17.9171 8.75109 18.018 9.04798 18.018ZM9.04798 14.018H14.9583C15.2535 14.018 15.5009 13.9175 15.7006 13.7167C15.9003 13.5159 16.0001 13.267 16.0001 12.9701C16.0001 12.6749 15.9003 12.4275 15.7006 12.2278C15.5009 12.0281 15.2535 11.9283 14.9583 11.9283H9.042C8.74682 11.9283 8.49937 12.0281 8.29967 12.2279C8.09999 12.4276 8.00015 12.675 8.00015 12.9702C8.00015 13.2655 8.10057 13.5139 8.3014 13.7155C8.50223 13.9171 8.75109 14.018 9.04798 14.018ZM6.0719 22.2033C5.44218 22.2033 4.90558 21.9816 4.4621 21.5381C4.01862 21.0946 3.79688 20.558 3.79688 19.9283V4.07178C3.79688 3.44206 4.01862 2.90546 4.4621 2.46198C4.90558 2.01849 5.44218 1.79675 6.0719 1.79675H13.1453C13.4488 1.79675 13.738 1.85373 14.0131 1.96768C14.2882 2.08163 14.5313 2.24422 14.7425 2.45545L19.5447 7.25763C19.756 7.46886 19.9185 7.71201 20.0325 7.98708C20.1465 8.26213 20.2034 8.55141 20.2034 8.85493V19.9283C20.2034 20.558 19.9817 21.0946 19.5382 21.5381C19.0947 21.9816 18.5581 22.2033 17.9284 22.2033H6.0719ZM12.9284 7.93428V4.07178H6.0719V19.9283H17.9284V9.07178H14.0659C13.7467 9.07178 13.4773 8.962 13.2578 8.74243C13.0382 8.52286 12.9284 8.25348 12.9284 7.93428Z"
        fill="#302F2E"
        fillOpacity="0.56"
      />
    </g>
  </svg>
);

export const EyeOffIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={25}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 .125h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.56}
        d="m15.45 12.775-.8-.8c.15-.867-.096-1.621-.737-2.263-.642-.641-1.396-.887-2.263-.737l-.8-.8c.167-.067.342-.117.525-.15.183-.033.392-.05.625-.05 1.017 0 1.88.354 2.588 1.062.708.709 1.062 1.571 1.062 2.588 0 .233-.017.446-.05.637a2.176 2.176 0 0 1-.15.513Zm3.15 3.075-.75-.675a10.952 10.952 0 0 0 1.688-1.588 8.895 8.895 0 0 0 1.262-1.962c-.833-1.683-2.03-3.021-3.588-4.013-1.558-.991-3.295-1.487-5.212-1.487-.483 0-.958.033-1.425.1a9.625 9.625 0 0 0-1.375.3l-.775-.775a9.64 9.64 0 0 1 1.775-.475c.6-.1 1.2-.15 1.8-.15 2.067 0 3.971.55 5.713 1.65 1.741 1.1 3.062 2.55 3.962 4.35a.896.896 0 0 1 .075.225c.017.083.025.175.025.275 0 .1-.008.192-.025.275a.893.893 0 0 1-.075.225 9.797 9.797 0 0 1-1.3 2A12.453 12.453 0 0 1 18.6 15.85Zm.775 5.05-3.55-3.525c-.433.2-.979.375-1.637.525a9.866 9.866 0 0 1-2.188.225c-2.083 0-3.992-.55-5.725-1.65-1.733-1.1-3.05-2.55-3.95-4.35a.89.89 0 0 1-.075-.225 1.404 1.404 0 0 1-.025-.275c0-.1.008-.192.025-.275a.893.893 0 0 1 .075-.225c.4-.783.892-1.513 1.475-2.188C4.383 8.262 5 7.683 5.65 7.2L3.2 4.75a.487.487 0 0 1-.138-.325c-.008-.133.046-.258.163-.375a.48.48 0 0 1 .7 0l16.15 16.15c.1.1.154.217.163.35a.414.414 0 0 1-.163.35.45.45 0 0 1-.35.175.45.45 0 0 1-.35-.175ZM6.35 7.9c-.567.417-1.15.958-1.75 1.625a8.246 8.246 0 0 0-1.4 2.1c.833 1.683 2.03 3.02 3.587 4.012 1.559.992 3.296 1.488 5.213 1.488.583 0 1.167-.054 1.75-.163.583-.108 1.025-.22 1.325-.337l-1.65-1.65c-.15.083-.367.154-.65.212a3.848 3.848 0 0 1-.775.088c-1.017 0-1.879-.354-2.587-1.063-.709-.708-1.063-1.57-1.063-2.587 0-.217.03-.463.088-.738.058-.275.129-.504.212-.687l-2.3-2.3Z"
      />
    </g>
  </svg>
);

export const EyeOnIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={25}
      height={25}
      x={-1}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M-.125.125h24v24h-24z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.56}
        d="M11.875 15.275c1.017 0 1.88-.354 2.588-1.063.708-.708 1.062-1.57 1.062-2.587 0-1.017-.354-1.88-1.062-2.588-.709-.708-1.571-1.062-2.588-1.062-1.017 0-1.879.354-2.587 1.062-.709.709-1.063 1.571-1.063 2.588 0 1.017.354 1.879 1.063 2.587.708.709 1.57 1.063 2.587 1.063Zm0-.95c-.75 0-1.387-.263-1.912-.788a2.601 2.601 0 0 1-.788-1.912c0-.75.263-1.388.788-1.913a2.603 2.603 0 0 1 1.912-.787c.75 0 1.388.262 1.913.787.525.525.787 1.163.787 1.913s-.262 1.387-.787 1.912a2.605 2.605 0 0 1-1.913.788Zm0 3.8c-2.067 0-3.963-.538-5.688-1.613-1.725-1.075-3.054-2.537-3.987-4.387a.893.893 0 0 1-.075-.225 1.404 1.404 0 0 1-.025-.275c0-.1.008-.192.025-.275a.893.893 0 0 1 .075-.225c.933-1.85 2.262-3.313 3.987-4.388 1.725-1.075 3.621-1.612 5.688-1.612 2.067 0 3.963.537 5.688 1.612 1.725 1.075 3.054 2.538 3.987 4.388a.896.896 0 0 1 .075.225c.017.083.025.175.025.275 0 .1-.008.192-.025.275a.896.896 0 0 1-.075.225c-.933 1.85-2.262 3.312-3.987 4.387-1.725 1.075-3.621 1.613-5.688 1.613Zm0-1a9.545 9.545 0 0 0 5.188-1.488 9.772 9.772 0 0 0 3.612-4.012 9.778 9.778 0 0 0-3.612-4.013 9.55 9.55 0 0 0-5.188-1.487 9.55 9.55 0 0 0-5.188 1.487 9.777 9.777 0 0 0-3.612 4.013 9.77 9.77 0 0 0 3.612 4.012 9.545 9.545 0 0 0 5.188 1.488Z"
      />
    </g>
  </svg>
);

export const LogoutIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill || "#302F2E"}
      fillOpacity={props?.fill ? 1 : 0.56}
      d="M9.494 10.206a.833.833 0 0 1-.207-.553.7.7 0 0 1 .207-.516L10.88 7.75H5.5a.726.726 0 0 1-.534-.216A.726.726 0 0 1 4.75 7c0-.213.072-.39.216-.534A.726.726 0 0 1 5.5 6.25h5.381L9.494 4.862a.73.73 0 0 1-.225-.534.73.73 0 0 1 .225-.534.67.67 0 0 1 .515-.225.7.7 0 0 1 .516.206l2.7 2.7a.659.659 0 0 1 .16.244.831.831 0 0 1 .046.281c0 .1-.015.194-.047.281a.659.659 0 0 1-.159.244l-2.7 2.7c-.162.162-.34.234-.534.216a.79.79 0 0 1-.497-.235ZM1.75 13.75c-.413 0-.766-.147-1.06-.44a1.445 1.445 0 0 1-.44-1.06V1.75c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44h4.5c.213 0 .39.072.534.216A.726.726 0 0 1 7 1c0 .212-.072.39-.216.534a.726.726 0 0 1-.534.216h-4.5v10.5h4.5c.213 0 .39.072.534.216A.726.726 0 0 1 7 13c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216h-4.5Z"
    />
  </svg>
);

export const TranslateIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={17}
    height={16}
    fill="none"
    {...props}
  >
    <path
      fill="#302F2E"
      fillOpacity={0.56}
      d="M10.012 15.5c-.3 0-.515-.097-.646-.29-.132-.194-.147-.435-.047-.723l2.737-7.256c.075-.2.216-.372.422-.515.206-.144.422-.216.647-.216.213 0 .425.072.637.216.213.143.357.315.432.515l2.737 7.257c.1.287.085.528-.047.721-.13.194-.353.291-.665.291a.596.596 0 0 1-.375-.131.754.754 0 0 1-.244-.319l-.637-1.838h-3.638l-.656 1.838a.71.71 0 0 1-.263.319.676.676 0 0 1-.394.131Zm1.763-3.6h2.7l-1.313-3.713h-.075L11.776 11.9ZM5.362 5.412c.2.363.413.697.638 1.004.225.306.487.621.787.946.55-.6 1.007-1.215 1.37-1.846.362-.632.668-1.303.918-2.016H1.5a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.212.072-.39.216-.534A.726.726 0 0 1 1.5 2H6v-.75c0-.212.072-.39.216-.534A.726.726 0 0 1 6.75.5c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534V2H12c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .212-.072.39-.216.534A.726.726 0 0 1 12 3.5h-1.425c-.262.888-.619 1.75-1.069 2.588A12.1 12.1 0 0 1 7.838 8.45l1.8 1.838-.563 1.537L6.75 9.5l-3.225 3.225a.711.711 0 0 1-.525.206.711.711 0 0 1-.525-.206.711.711 0 0 1-.206-.525c0-.212.068-.387.206-.525l3.262-3.263c-.337-.387-.65-.778-.937-1.171a9.405 9.405 0 0 1-.769-1.247c-.137-.263-.143-.494-.018-.694.125-.2.343-.3.656-.3.125 0 .256.04.394.122a.79.79 0 0 1 .3.29Z"
    />
  </svg>
);

export const LoadingIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={65}
    height={66}
    fill="none"
    {...props}
  >
    <path
      fill="#F8D1C0"
      d="M2.206 43.315c3.643-10.52 10.934-19.83 21.331-25.832 10.397-6.003 22.104-7.663 33.037-5.557C46.718.64 29.959-2.483 16.497 5.289 3.036 13.061-2.633 29.134 2.207 43.315Z"
    />
    <path
      fill="#D9ECF1"
      d="M24.089 48.823c-10.6-5.638-18.211-14.686-22.221-25.075-4.346 14.334 1.886 30.209 15.61 37.508 13.725 7.3 30.367 3.59 39.818-8.03-10.849 2.48-22.607 1.235-33.207-4.403Z"
    />
    <path
      fill="#B8722A"
      d="M50.408 33.628c-.418 11.999-5.219 22.804-12.791 30.96 14.789-2.376 26.32-14.938 26.86-30.474C65.019 18.58 54.39 5.25 39.807 1.838c6.991 8.667 11.022 19.782 10.604 31.781l-.002.009Z"
    />
  </svg>
);

export const BurgerIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#222E42"
      d="M18.13 5.94H7.99c-2.5 0-4.68 1.3-5.94 3.25 1.1-.71 2.41-1.13 3.82-1.13h10.14c2.5 0 4.68-1.3 5.94-3.25-1.1.71-2.41 1.13-3.82 1.13ZM18.13 10.94H7.99c-2.5 0-4.68 1.3-5.94 3.25 1.1-.71 2.41-1.13 3.82-1.13h10.14c2.5 0 4.68-1.3 5.94-3.25-1.1.71-2.41 1.13-3.82 1.13ZM18.13 15.94H7.99c-2.5 0-4.68 1.3-5.94 3.25 1.1-.71 2.41-1.13 3.82-1.13h10.14c2.5 0 4.68-1.3 5.94-3.25-1.1.71-2.41 1.13-3.82 1.13Z"
    />
  </svg>
);

export const CloseIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path
      fill="#222E42"
      d="m12.148 13.24 2.778 3.005c1.377 1.489 3.3 2.032 5.074 1.623a5.424 5.424 0 0 1-2.773-1.623l-3.92-4.24 3.914-4.246a5.437 5.437 0 0 1 2.773-1.63c-1.774-.402-3.697.134-5.074 1.624L11 11.992"
    />
    <path
      fill="#222E42"
      d="M11.852 10.76 9.074 7.755C7.697 6.266 5.774 5.723 4 6.132a5.424 5.424 0 0 1 2.773 1.623l3.92 4.24-3.914 4.246a5.437 5.437 0 0 1-2.773 1.63c1.774.402 3.697-.134 5.074-1.624L13 12.008"
    />
  </svg>
);

export const ArrowLeftIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.95}
        d="m13.3 17.3-4.6-4.6a.877.877 0 0 1-.213-.325A1.107 1.107 0 0 1 8.425 12c0-.133.02-.258.062-.375A.877.877 0 0 1 8.7 11.3l4.6-4.6a.948.948 0 0 1 .7-.275c.283 0 .517.092.7.275a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7L10.8 12l3.9 3.9a.948.948 0 0 1 .275.7.948.948 0 0 1-.275.7.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275Z"
      />
    </g>
  </svg>
);

export const ArrowRightIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.95}
        d="M8.7 17.3a.948.948 0 0 1-.275-.7c0-.283.091-.517.275-.7l3.9-3.9-3.9-3.9a.948.948 0 0 1-.275-.7c0-.283.091-.517.275-.7a.948.948 0 0 1 .7-.275c.283 0 .516.092.7.275l4.6 4.6c.1.1.17.208.212.325.042.117.063.242.063.375s-.021.258-.063.375a.877.877 0 0 1-.212.325l-4.6 4.6a.948.948 0 0 1-.7.275.948.948 0 0 1-.7-.275Z"
      />
    </g>
  </svg>
);

export const ThreeDotsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <path
      fill="#302F2E"
      fillOpacity={0.56}
      d="M10 6.667c.917 0 1.667-.75 1.667-1.667S10.917 3.333 10 3.333 8.333 4.083 8.333 5 9.083 6.667 10 6.667Zm0 1.666c-.917 0-1.667.75-1.667 1.667s.75 1.667 1.667 1.667 1.667-.75 1.667-1.667-.75-1.667-1.667-1.667Zm0 5c-.917 0-1.667.75-1.667 1.667s.75 1.667 1.667 1.667 1.667-.75 1.667-1.667-.75-1.667-1.667-1.667Z"
    />
  </svg>
);

export const DownloadIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="aDownloadIcon"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.95}
        d="M5 16.667c-.458 0-.85-.164-1.177-.49A1.605 1.605 0 0 1 3.333 15v-2.5H5V15h10v-2.5h1.667V15c0 .458-.164.85-.49 1.177-.326.326-.719.49-1.177.49H5Zm5-3.334L5.833 9.167 7 7.958l2.167 2.167V3.333h1.666v6.792L13 7.958l1.167 1.209L10 13.333Z"
      />
    </g>
  </svg>
);

export const EmptyCustomersIcon = (props: any) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1020_42882"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <rect width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1020_42882)">
      <path
        d="M2.60291 27.0732C2.17731 27.0732 1.81813 26.9268 1.52538 26.634C1.23262 26.3413 1.08624 25.9821 1.08624 25.5565V23.0529C1.08624 22.2479 1.29449 21.508 1.71098 20.8332C2.12749 20.1584 2.68083 19.6435 3.37101 19.2884C4.76474 18.5942 6.18323 18.0722 7.62648 17.7224C9.06974 17.3727 10.5356 17.1978 12.0239 17.1978C13.5225 17.1978 14.9935 17.3713 16.437 17.7184C17.8804 18.0655 19.2937 18.5862 20.6768 19.2804C21.367 19.6348 21.9204 20.1486 22.3369 20.8219C22.7534 21.4952 22.9616 22.2389 22.9616 23.0529V25.5565C22.9616 25.9821 22.8152 26.3413 22.5225 26.634C22.2297 26.9268 21.8705 27.0732 21.4449 27.0732H2.60291ZM25.0268 27.0732C25.2481 26.8963 25.4236 26.6757 25.5533 26.4112C25.683 26.1466 25.7478 25.8506 25.7478 25.5232V22.8101C25.7478 21.8111 25.4783 20.8483 24.9391 19.9217C24.4 18.9951 23.6225 18.1698 22.6065 17.4456C23.6814 17.5896 24.6976 17.8187 25.6551 18.1329C26.6126 18.4472 27.514 18.8297 28.3594 19.2804C29.1807 19.7248 29.8117 20.2493 30.2525 20.8539C30.6934 21.4584 30.9138 22.1184 30.9138 22.834V25.5565C30.9138 25.9821 30.7674 26.3413 30.4746 26.634C30.1819 26.9268 29.8227 27.0732 29.3971 27.0732H25.0268ZM12.0239 15.8645C10.5147 15.8645 9.22597 15.3303 8.15761 14.2619C7.08925 13.1935 6.55508 11.9048 6.55508 10.3956C6.55508 8.88641 7.08925 7.59765 8.15761 6.52929C9.22597 5.46094 10.5147 4.92676 12.0239 4.92676C13.5331 4.92676 14.8219 5.46094 15.8902 6.52929C16.9586 7.59765 17.4928 8.88641 17.4928 10.3956C17.4928 11.9048 16.9586 13.1935 15.8902 14.2619C14.8219 15.3303 13.5331 15.8645 12.0239 15.8645ZM25.7478 10.3955C25.7478 11.8994 25.2125 13.1869 24.1417 14.2579C23.071 15.3289 21.7839 15.8645 20.2803 15.8645C20.0297 15.8645 19.7181 15.8353 19.3457 15.7771C18.9732 15.7189 18.6541 15.6512 18.3884 15.5739C18.9991 14.8521 19.4668 14.0477 19.7917 13.1606C20.1166 12.2734 20.279 11.3522 20.279 10.3968C20.279 9.44141 20.1166 8.51976 19.7917 7.63182C19.4668 6.74391 18.9991 5.93908 18.3884 5.21732C18.7048 5.1009 19.0186 5.02337 19.3297 4.98472C19.6408 4.94608 19.956 4.92676 20.2752 4.92676C21.7802 4.92676 23.0685 5.46225 24.1403 6.53322C25.212 7.60418 25.7478 8.89161 25.7478 10.3955ZM4.11958 24.0398H19.9283V23.0927C19.9283 22.8534 19.8672 22.6359 19.7449 22.4401C19.6227 22.2443 19.4616 22.0921 19.2616 21.9833C18.0935 21.4046 16.9063 20.9678 15.7 20.6732C14.4937 20.3785 13.2684 20.2311 12.0239 20.2311C10.7901 20.2311 9.56475 20.3785 8.34784 20.6732C7.13093 20.9678 5.94373 21.4046 4.78624 21.9833C4.58624 22.0921 4.42513 22.2443 4.30291 22.4401C4.18069 22.6359 4.11958 22.8534 4.11958 23.0927V24.0398ZM12.0226 12.9507C12.725 12.9507 13.3266 12.7006 13.8275 12.2005C14.3285 11.7004 14.579 11.0992 14.579 10.3969C14.579 9.69457 14.3289 9.09295 13.8288 8.59199C13.3287 8.09101 12.7275 7.84053 12.0252 7.84053C11.3229 7.84053 10.7213 8.09059 10.2203 8.59072C9.71933 9.09084 9.46884 9.69204 9.46884 10.3943C9.46884 11.0966 9.71891 11.6983 10.219 12.1992C10.7192 12.7002 11.3204 12.9507 12.0226 12.9507Z"
        fill="#114B5B"
      />
    </g>
  </svg>
);

export const EmptyEquipmentIcon = (props: any) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1386_54254"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <rect
        y="32"
        width="32"
        height="32"
        transform="rotate(-90 0 32)"
        fill="#D9D9D9"
      />
    </mask>
    <g mask="url(#mask0_1386_54254)">
      <path
        d="M27.9998 6.66671L18.6665 16L21.7998 19.1334C22.1332 18.9556 22.4887 18.8334 22.8665 18.7667C23.2443 18.7 23.6221 18.6667 23.9998 18.6667C25.4665 18.6667 26.7221 19.1889 27.7665 20.2334C28.8109 21.2778 29.3332 22.5334 29.3332 24C29.3332 25.4667 28.8109 26.7223 27.7665 27.7667C26.7221 28.8112 25.4665 29.3334 23.9998 29.3334C22.5332 29.3334 21.2776 28.8112 20.2332 27.7667C19.1887 26.7223 18.6665 25.4667 18.6665 24C18.6665 23.6223 18.6998 23.2445 18.7665 22.8667C18.8332 22.4889 18.9554 22.1334 19.1332 21.8L15.9998 18.6667L12.8665 21.8C13.0443 22.1334 13.1665 22.4889 13.2332 22.8667C13.2998 23.2445 13.3332 23.6223 13.3332 24C13.3332 25.4667 12.8109 26.7223 11.7665 27.7667C10.7221 28.8112 9.4665 29.3334 7.99984 29.3334C6.53317 29.3334 5.27761 28.8112 4.23317 27.7667C3.18873 26.7223 2.6665 25.4667 2.6665 24C2.6665 22.5334 3.18873 21.2778 4.23317 20.2334C5.27761 19.1889 6.53317 18.6667 7.99984 18.6667C8.37761 18.6667 8.75539 18.7 9.13317 18.7667C9.51095 18.8334 9.8665 18.9556 10.1998 19.1334L26.6665 2.66671L27.9998 2.66671L27.9998 6.66671ZM14.6665 12L11.9998 14.6667L3.99984 6.66671L3.99984 2.66671L5.33317 2.66671L14.6665 12ZM10.6665 24C10.6665 23.2667 10.4054 22.6389 9.88317 22.1167C9.36095 21.5945 8.73317 21.3334 7.99984 21.3334C7.2665 21.3334 6.63873 21.5945 6.1165 22.1167C5.59428 22.6389 5.33317 23.2667 5.33317 24C5.33317 24.7334 5.59428 25.3612 6.1165 25.8834C6.63873 26.4056 7.2665 26.6667 7.99984 26.6667C8.73317 26.6667 9.36095 26.4056 9.88317 25.8834C10.4054 25.3612 10.6665 24.7334 10.6665 24ZM16.6665 16C16.6665 15.8223 16.5998 15.6667 16.4665 15.5334C16.3332 15.4 16.1776 15.3334 15.9998 15.3334C15.8221 15.3334 15.6665 15.4 15.5332 15.5334C15.3998 15.6667 15.3332 15.8223 15.3332 16C15.3332 16.1778 15.3998 16.3334 15.5332 16.4667C15.6665 16.6 15.8221 16.6667 15.9998 16.6667C16.1776 16.6667 16.3332 16.6 16.4665 16.4667C16.5998 16.3334 16.6665 16.1778 16.6665 16ZM26.6665 24C26.6665 23.2667 26.4054 22.6389 25.8832 22.1167C25.3609 21.5945 24.7332 21.3334 23.9998 21.3334C23.2665 21.3334 22.6387 21.5945 22.1165 22.1167C21.5943 22.6389 21.3332 23.2667 21.3332 24C21.3332 24.7334 21.5943 25.3612 22.1165 25.8834C22.6387 26.4056 23.2665 26.6667 23.9998 26.6667C24.7332 26.6667 25.3609 26.4056 25.8832 25.8834C26.4054 25.3612 26.6665 24.7334 26.6665 24Z"
        fill="#114B5B"
      />
    </g>
  </svg>
);

export const EmptyServiceIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#114B5B"
      fillRule="evenodd"
      d="M23.667 13.707V25H8.333V13.707a8.004 8.004 0 0 1 15.334 0Zm-18.334-.374C5.334 7.443 10.11 2.667 16 2.667s10.667 4.775 10.667 10.666V28H5.333V13.333Z"
      clipRule="evenodd"
      opacity={0.8}
    />
  </svg>
);

export const EmptyMenuIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#114B5B"
      d="M25.507 9.92H9.32c-3.333 0-6.24 1.733-7.92 4.333a9.364 9.364 0 0 1 5.093-1.506H22.68c3.333 0 6.24-1.734 7.92-4.334a9.364 9.364 0 0 1-5.093 1.507ZM18.747 19.253H9.32c-3.333 0-6.24 1.734-7.92 4.334a9.364 9.364 0 0 1 5.093-1.507h9.52c3.334 0 6.24-1.733 7.92-4.333a9.363 9.363 0 0 1-5.093 1.506h-.093Z"
    />
  </svg>
);

export const EmptyLocationIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#114B5B"
      d="M22.667 9.333A9.41 9.41 0 0 1 25.213 14c.654-3.027-.186-6.32-2.546-8.667-3.68-3.68-9.654-3.68-13.334 0A9.433 9.433 0 0 0 6.788 14a9.411 9.411 0 0 1 2.547-4.667c3.68-3.68 9.653-3.68 13.333 0ZM22.667 18.667 16 25.333l-6.667-6.666A9.411 9.411 0 0 1 6.787 14c-.654 3.027.186 6.32 2.546 8.667L16 29.333l6.667-6.666A9.433 9.433 0 0 0 25.213 14a9.412 9.412 0 0 1-2.546 4.667Z"
    />
    <path
      fill="#114B5B"
      d="M16 16.667a2.667 2.667 0 1 0 0-5.334 2.667 2.667 0 0 0 0 5.334Z"
    />
  </svg>
);

export const EmptyStaffIcon = (props: any) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_1_3"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <rect width="32" height="32" fill="#114B5B" />
    </mask>
    <g mask="url(#mask0_1_3)">
      <path
        d="M12.0399 19.0239C11.5626 19.0239 11.1615 18.8615 10.8366 18.5366C10.5117 18.2117 10.3493 17.8106 10.3493 17.3333C10.3493 16.856 10.5117 16.455 10.8366 16.1301C11.1615 15.8052 11.5626 15.6428 12.0399 15.6428C12.5172 15.6428 12.9182 15.8052 13.2431 16.1301C13.568 16.455 13.7304 16.856 13.7304 17.3333C13.7304 17.8106 13.568 18.2117 13.2431 18.5366C12.9182 18.8615 12.5172 19.0239 12.0399 19.0239ZM19.9601 19.0239C19.4828 19.0239 19.0818 18.8615 18.7569 18.5366C18.432 18.2117 18.2696 17.8106 18.2696 17.3333C18.2696 16.856 18.432 16.455 18.7569 16.1301C19.0818 15.8052 19.4828 15.6428 19.9601 15.6428C20.4374 15.6428 20.8385 15.8052 21.1634 16.1301C21.4883 16.455 21.6507 16.856 21.6507 17.3333C21.6507 17.8106 21.4883 18.2117 21.1634 18.5366C20.8385 18.8615 20.4374 19.0239 19.9601 19.0239ZM16 26.571C18.9459 26.571 21.4455 25.5485 23.4989 23.5034C25.5523 21.4584 26.579 18.9626 26.579 16.0159C26.579 15.4826 26.5457 14.9699 26.479 14.4777C26.4123 13.9855 26.2901 13.5089 26.1123 13.0478C25.6457 13.1589 25.183 13.2423 24.7243 13.2978C24.2656 13.3534 23.7807 13.3812 23.2696 13.3812C21.2633 13.3812 19.3694 12.9518 17.588 12.0931C15.8066 11.2344 14.2853 10.0326 13.0239 8.48767C12.3234 10.1998 11.3174 11.688 10.0058 12.9525C8.6942 14.217 7.17125 15.1715 5.43697 15.8159V16.0159C5.43697 18.9626 6.461 21.4584 8.50907 23.5034C10.5571 25.5485 13.0541 26.571 16 26.571ZM16.008 29.6044C14.1269 29.6044 12.3592 29.2477 10.7048 28.5344C9.0504 27.8211 7.60991 26.8512 6.38333 25.6246C5.15676 24.3981 4.18682 22.9575 3.47353 21.303C2.76027 19.6484 2.40363 17.8805 2.40363 15.9993C2.40363 14.1181 2.76027 12.3505 3.47353 10.6964C4.18682 9.04226 5.15676 7.60192 6.38333 6.37537C7.60991 5.14879 9.05047 4.17886 10.705 3.46557C12.3596 2.75228 14.1274 2.39563 16.0086 2.39563C17.8898 2.39563 19.6562 2.75228 21.3076 3.46557C22.9591 4.17886 24.3981 5.14879 25.6246 6.37537C26.8512 7.60192 27.8211 9.04248 28.5344 10.697C29.2477 12.3516 29.6044 14.1195 29.6044 16.0007C29.6044 17.8819 29.2477 19.6495 28.5344 21.3036C27.8211 22.9577 26.8512 24.3981 25.6246 25.6246C24.3981 26.8512 22.9584 27.8211 21.3057 28.5344C19.653 29.2477 17.8871 29.6044 16.008 29.6044ZM14.2 5.5C15.1333 7.05556 16.4 8.30556 18 9.25C19.6 10.1944 21.3778 10.6667 23.3333 10.6667C23.6444 10.6667 23.9444 10.65 24.2333 10.6167C24.5222 10.5833 24.8222 10.5444 25.1333 10.5C24.2 8.94445 22.9333 7.69444 21.3333 6.75C19.7333 5.80556 17.9556 5.33333 16 5.33333C15.6889 5.33333 15.3889 5.35 15.1 5.38333C14.8111 5.41667 14.5111 5.45556 14.2 5.5ZM5.9 12.6333C7.03333 11.9889 8.02222 11.1556 8.86667 10.1333C9.71111 9.11111 10.3444 7.96667 10.7667 6.7C9.63333 7.34445 8.64444 8.17778 7.8 9.2C6.95556 10.2222 6.32222 11.3667 5.9 12.6333Z"
        fill="#114B5B"
      />
    </g>
  </svg>
);

export const EmptyOrderIcon = (props: any) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2_6"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <rect width="32" height="32" fill="#114B5B" />
    </mask>
    <g mask="url(#mask0_2_6)">
      <path
        d="M13.3333 21.3333H14.6667C14.6667 21.7111 14.7944 22.0278 15.05 22.2833C15.3056 22.5389 15.6222 22.6667 16 22.6667C16.3778 22.6667 16.6944 22.5389 16.95 22.2833C17.2056 22.0278 17.3333 21.7111 17.3333 21.3333H18.6667C19.0444 21.3333 19.3611 21.2056 19.6167 20.95C19.8722 20.6944 20 20.3778 20 20V16C20 15.6222 19.8722 15.3056 19.6167 15.05C19.3611 14.7944 19.0444 14.6667 18.6667 14.6667H14.6667V13.3333H18.6667C19.0444 13.3333 19.3611 13.2056 19.6167 12.95C19.8722 12.6944 20 12.3778 20 12C20 11.6222 19.8722 11.3056 19.6167 11.05C19.3611 10.7944 19.0444 10.6667 18.6667 10.6667H17.3333C17.3333 10.2889 17.2056 9.97222 16.95 9.71667C16.6944 9.46111 16.3778 9.33333 16 9.33333C15.6222 9.33333 15.3056 9.46111 15.05 9.71667C14.7944 9.97222 14.6667 10.2889 14.6667 10.6667H13.3333C12.9556 10.6667 12.6389 10.7944 12.3833 11.05C12.1278 11.3056 12 11.6222 12 12V16C12 16.3778 12.1278 16.6944 12.3833 16.95C12.6389 17.2056 12.9556 17.3333 13.3333 17.3333H17.3333V18.6667H13.3333C12.9556 18.6667 12.6389 18.7944 12.3833 19.05C12.1278 19.3056 12 19.6222 12 20C12 20.3778 12.1278 20.6944 12.3833 20.95C12.6389 21.2056 12.9556 21.3333 13.3333 21.3333ZM5.429 26.9377C4.58938 26.9377 3.87391 26.642 3.2826 26.0507C2.69131 25.4594 2.39567 24.744 2.39567 23.9043V8.09567C2.39567 7.25604 2.69133 6.54058 3.28267 5.94927C3.87395 5.35796 4.58941 5.0623 5.42903 5.0623H26.571C27.4107 5.0623 28.1261 5.35796 28.7174 5.94927C29.3087 6.54058 29.6044 7.25604 29.6044 8.09567V23.9043C29.6044 24.744 29.3087 25.4594 28.7174 26.0507C28.1261 26.642 27.4107 26.9377 26.571 26.9377H5.429ZM5.429 23.9043H26.571V8.09567H5.429V23.9043Z"
        fill="#114B5B"
      />
    </g>
  </svg>
);

export const EmptyAppointmentIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={33}
    height={32}
    fill="none"
    {...props}
  >
    <path
      fill="#114B5B"
      d="M9.389 7.436v-.664c0-1.033.48-1.883 1.514-1.883h1.22v23.803h-1.22c-.96 0-1.514-.702-1.514-1.663V7.436ZM19.206 5.01a8.438 8.438 0 0 0-.715-.05h-2.175c3.815.085 7.567 2.828 7.567 8.19 0 5.36-3.724 8.08-7.521 8.186h2.15c3.797-.108 7.516-2.851 7.516-8.187 0-5.014-3.282-7.735-6.825-8.14h.003Z"
    />
    <path
      fill="#114B5B"
      d="M21.469 13.147c0-3.782-1.662-6.26-4.102-7.42a8.013 8.013 0 0 0-3.444-.77v.767c2.522 0 5.009 2.487 5.009 7.423s-2.487 7.387-5.01 7.387v.805a8.04 8.04 0 0 0 3.523-.805c2.402-1.176 4.026-3.643 4.026-7.385l-.002-.002Z"
    />
  </svg>
);

export const EditButtonIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.95}
        d="M4.167 15.833h1.166l7.188-7.187-1.167-1.167-7.187 7.188v1.166Zm11.916-8.395-3.541-3.5 1.166-1.167a1.6 1.6 0 0 1 1.177-.48 1.6 1.6 0 0 1 1.178.48l1.166 1.167c.32.319.486.704.5 1.156.014.451-.139.837-.458 1.156l-1.188 1.188ZM3.333 17.5a.806.806 0 0 1-.593-.24.806.806 0 0 1-.24-.593v-2.354a.862.862 0 0 1 .25-.605l8.583-8.583 3.542 3.542-8.583 8.583a.834.834 0 0 1-.604.25H3.333Z"
      />
    </g>
  </svg>
);

export const ShowButtonIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.95}
        d="M10 13.333c1.041 0 1.927-.364 2.656-1.093.73-.73 1.094-1.615 1.094-2.657 0-1.041-.365-1.927-1.094-2.656-.73-.729-1.615-1.094-2.656-1.094-1.042 0-1.927.365-2.656 1.094-.73.73-1.094 1.615-1.094 2.656 0 1.042.364 1.928 1.094 2.657.729.729 1.614 1.093 2.656 1.093Zm0-1.5a2.17 2.17 0 0 1-1.594-.656 2.17 2.17 0 0 1-.656-1.594c0-.625.219-1.156.656-1.593A2.17 2.17 0 0 1 10 7.333a2.17 2.17 0 0 1 1.594.657c.437.437.656.968.656 1.593a2.17 2.17 0 0 1-.656 1.594 2.17 2.17 0 0 1-1.594.656Zm0 4c-1.93 0-3.695-.51-5.292-1.53-1.597-1.022-2.805-2.4-3.625-4.136A.676.676 0 0 1 1 9.907a2.442 2.442 0 0 1 0-.647.677.677 0 0 1 .083-.26c.82-1.736 2.028-3.115 3.625-4.135C6.305 3.844 8.07 3.333 10 3.333c1.93 0 3.694.51 5.291 1.532C16.89 5.885 18.098 7.264 18.916 9c.042.07.07.156.084.26a2.44 2.44 0 0 1 0 .646.676.676 0 0 1-.084.26c-.819 1.737-2.027 3.115-3.625 4.136-1.597 1.021-3.36 1.531-5.291 1.531Zm0-1.666c1.57 0 3.01-.413 4.323-1.24a8.144 8.144 0 0 0 3.01-3.344 8.144 8.144 0 0 0-3.01-3.343A7.954 7.954 0 0 0 10 5c-1.57 0-3.01.413-4.323 1.24a8.144 8.144 0 0 0-3.01 3.343 8.144 8.144 0 0 0 3.01 3.344A7.954 7.954 0 0 0 10 14.167Z"
      />
    </g>
  </svg>
);

export const PersonIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g fill="#114B5B" opacity={0.8}>
      <path d="M9 1.5c-2.07 0-3.75 1.68-3.75 3.75C5.25 7.32 6.93 9 9 9c2.07 0 3.75-1.68 3.75-3.75 0-2.07-1.68-3.75-3.75-3.75Zm0 6a2.247 2.247 0 0 1-2.25-2.25A2.247 2.247 0 0 1 9 3a2.247 2.247 0 0 1 2.25 2.25A2.247 2.247 0 0 1 9 7.5ZM9 13.56c2.535 0 4.875.787 6.81 2.13-1.185-2.58-3.788-4.38-6.81-4.38a7.487 7.487 0 0 0-6.81 4.38A11.965 11.965 0 0 1 9 13.56Z" />
    </g>
  </svg>
);

export const AppointmentDetailsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g fill="#114B5B" opacity={0.8}>
      <path d="M5 4.183v-.374c0-.58.27-1.059.851-1.059h.686v13.389h-.686c-.54 0-.851-.395-.851-.935V4.183ZM10.522 2.818a4.75 4.75 0 0 0-.401-.028H8.897c2.146.048 4.256 1.59 4.256 4.606s-2.095 4.546-4.23 4.606h1.209c2.136-.061 4.228-1.604 4.228-4.606 0-2.82-1.846-4.35-3.84-4.578h.002Z" />
      <path d="M11.794 7.395c0-2.127-.934-3.52-2.306-4.174a4.507 4.507 0 0 0-1.938-.433v.432c1.418 0 2.817 1.398 2.817 4.175s-1.399 4.156-2.817 4.156v.452c.683 0 1.365-.151 1.981-.452 1.351-.662 2.265-2.05 2.265-4.155l-.002-.001Z" />
    </g>
  </svg>
);

export const StaffDetailsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={18}
      height={18}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#114B5B" d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#114B5B"
        fillOpacity={0.8}
        d="M6.772 10.7a.92.92 0 0 1-.676-.273.92.92 0 0 1-.275-.677.92.92 0 0 1 .275-.677.92.92 0 0 1 .676-.274.92.92 0 0 1 .677.274.92.92 0 0 1 .274.677.92.92 0 0 1-.274.677.92.92 0 0 1-.677.274Zm4.456 0a.92.92 0 0 1-.677-.273.92.92 0 0 1-.274-.677.92.92 0 0 1 .274-.677.92.92 0 0 1 .677-.274.92.92 0 0 1 .676.274.92.92 0 0 1 .274.677.92.92 0 0 1-.274.677.92.92 0 0 1-.676.274ZM9 14.947c1.657 0 3.063-.575 4.218-1.725 1.155-1.15 1.733-2.555 1.733-4.212 0-.3-.02-.588-.057-.865a3.554 3.554 0 0 0-.206-.805c-.262.063-.523.11-.78.141-.259.031-.531.047-.819.047a7.266 7.266 0 0 1-3.196-.725 7.46 7.46 0 0 1-2.567-2.028c-.394.963-.96 1.8-1.698 2.512a7.349 7.349 0 0 1-2.57 1.61v.113c0 1.657.576 3.061 1.728 4.212C5.938 14.37 7.343 14.946 9 14.946Zm.004 1.707c-1.058 0-2.052-.201-2.983-.602a7.726 7.726 0 0 1-2.43-1.637 7.726 7.726 0 0 1-1.637-2.431A7.455 7.455 0 0 1 1.352 9c0-1.059.2-2.053.602-2.983.401-.93.947-1.74 1.637-2.43.69-.69 1.5-1.236 2.43-1.638a7.455 7.455 0 0 1 2.984-.601c1.058 0 2.052.2 2.98.601a7.733 7.733 0 0 1 2.429 1.637c.69.69 1.235 1.5 1.637 2.431.4.93.602 1.925.602 2.983 0 1.059-.201 2.053-.602 2.983a7.728 7.728 0 0 1-1.637 2.43c-.69.69-1.5 1.236-2.43 1.638a7.44 7.44 0 0 1-2.98.602ZM7.988 3.092a6.012 6.012 0 0 0 2.137 2.11c.9.531 1.9.797 3 .797.175 0 .344-.01.506-.028.163-.019.332-.04.506-.066A6.012 6.012 0 0 0 12 3.796C11.1 3.267 10.1 3 9 3c-.175 0-.344.01-.506.028-.163.019-.332.04-.506.066Zm-4.67 4.013A5.99 5.99 0 0 0 4.989 5.7a5.97 5.97 0 0 0 1.068-1.931 5.99 5.99 0 0 0-1.668 1.406 5.97 5.97 0 0 0-1.07 1.931Z"
      />
    </g>
  </svg>
);

export const CompanyDetailsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={16}
    fill="none"
    {...props}
  >
    <g fill="#114B5B">
      <path d="M5.909.052a8.246 8.246 0 0 0-.698-.05H3.087c3.726.084 7.39 2.764 7.39 8 0 5.235-3.637 7.893-7.346 7.996h2.1c3.708-.106 7.34-2.785 7.34-7.997 0-4.897-3.204-7.554-6.665-7.95h.003Z" />
      <path d="M8.12 7.999c0-3.694-1.623-6.113-4.005-7.248A7.826 7.826 0 0 0 .75 0v.749c2.463 0 4.892 2.429 4.892 7.25 0 4.82-2.429 7.215-4.892 7.215V16c1.186 0 2.37-.263 3.44-.786 2.346-1.15 3.933-3.558 3.933-7.213L8.12 8Z" />
    </g>
  </svg>
);

export const LocationDetailsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g fill="#114B5B" opacity={0.8}>
      <path d="M12.75 5.25a5.294 5.294 0 0 1 1.433 2.625A5.287 5.287 0 0 0 12.75 3a5.305 5.305 0 0 0-7.5 0 5.306 5.306 0 0 0-1.432 4.875A5.305 5.305 0 0 1 12.75 5.25ZM12.75 10.5 9 14.25 5.25 10.5a5.294 5.294 0 0 1-1.432-2.625A5.287 5.287 0 0 0 5.25 12.75L9 16.5l3.75-3.75a5.306 5.306 0 0 0 1.433-4.875A5.294 5.294 0 0 1 12.75 10.5Z" />
      <path d="M9 9.375a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z" />
    </g>
  </svg>
);

export const MenuDetailsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g fill="#114B5B" opacity={0.8}>
      <path d="M14.347 5.58H5.242c-1.875 0-3.51.975-4.455 2.438a5.267 5.267 0 0 1 2.865-.848h9.105c1.875 0 3.51-.975 4.455-2.437a5.267 5.267 0 0 1-2.865.847ZM10.545 10.83H5.242c-1.875 0-3.51.975-4.455 2.438a5.267 5.267 0 0 1 2.865-.848h5.355c1.875 0 3.51-.975 4.455-2.437a5.267 5.267 0 0 1-2.865.847h-.052Z" />
    </g>
  </svg>
);

export const ServiceDetailsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <path
      fill="#114B5B"
      fillRule="evenodd"
      d="M13.5 9a4.5 4.5 0 1 0-9 0v5.25h9V9ZM3 7.5a6 6 0 1 1 12 0v8.25H3V7.5Z"
      clipRule="evenodd"
      opacity={0.8}
    />
  </svg>
);

export const ItemDetailsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g opacity={0.8}>
      <mask
        id="a"
        width={18}
        height={18}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha"
        }}
      >
        <path fill="#D9D9D9" d="M0 18V0h18v18z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#114B5B"
          d="M15.75 3.75 10.5 9l1.762 1.762c.188-.1.388-.168.6-.206.213-.037.425-.056.638-.056.825 0 1.531.294 2.119.881.587.588.881 1.294.881 2.119 0 .825-.294 1.531-.881 2.119a2.889 2.889 0 0 1-2.119.881 2.889 2.889 0 0 1-2.119-.881A2.889 2.889 0 0 1 10.5 13.5c0-.213.019-.425.056-.637.038-.213.107-.413.207-.6L9 10.5l-1.763 1.762c.1.188.17.388.207.6.037.213.056.425.056.638 0 .825-.294 1.531-.881 2.119A2.889 2.889 0 0 1 4.5 16.5a2.889 2.889 0 0 1-2.119-.881A2.889 2.889 0 0 1 1.5 13.5c0-.825.294-1.531.881-2.119A2.889 2.889 0 0 1 4.5 10.5c.213 0 .425.019.638.056.212.038.412.107.6.207L15 1.5h.75v2.25Zm-7.5 3-1.5 1.5-4.5-4.5V1.5H3l5.25 5.25ZM6 13.5c0-.412-.147-.766-.44-1.06A1.445 1.445 0 0 0 4.5 12c-.412 0-.766.147-1.06.44-.293.294-.44.648-.44 1.06 0 .412.147.766.44 1.06.294.293.648.44 1.06.44.412 0 .766-.147 1.06-.44.293-.294.44-.648.44-1.06ZM9.375 9a.36.36 0 0 0-.113-.262.36.36 0 0 0-.524 0 .36.36 0 0 0 0 .524.36.36 0 0 0 .524 0A.36.36 0 0 0 9.375 9ZM15 13.5c0-.412-.147-.766-.44-1.06A1.445 1.445 0 0 0 13.5 12c-.412 0-.766.147-1.06.44-.293.294-.44.648-.44 1.06 0 .412.147.766.44 1.06.294.293.648.44 1.06.44.412 0 .766-.147 1.06-.44.293-.294.44-.648.44-1.06Z"
        />
      </g>
    </g>
  </svg>
);

export const StarIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={8}
    height={8}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#EF5B1B"
        d="m4 5.924 2.06 1.243-.547-2.343 1.82-1.577-2.396-.203L4 .834l-.937 2.21-2.396.203 1.82 1.577-.547 2.343L4 5.924Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h8v8H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const VisaIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path fill="#0E4595" d="M24 4.308H0v15.384h24V4.308Z" />
      <path
        fill="#fff"
        d="m9.021 15.038 1.027-6.024h1.642l-1.027 6.024H9.02Zm7.573-5.894a4.24 4.24 0 0 0-1.471-.253c-1.623 0-2.765.817-2.775 1.988-.01.865.816 1.348 1.438 1.636.64.296.854.484.851.748-.004.403-.51.588-.982.588-.657 0-1.006-.092-1.545-.316l-.212-.096-.23 1.348c.383.168 1.092.314 1.829.322 1.725 0 2.846-.808 2.858-2.058.006-.685-.43-1.207-1.378-1.637-.574-.278-.925-.464-.922-.747 0-.25.298-.518.94-.518a3.03 3.03 0 0 1 1.23.231l.146.07.223-1.306Zm4.225-.13H19.55c-.393 0-.687.107-.86.5l-2.438 5.52h1.724s.282-.743.346-.905l2.103.002c.049.21.2.903.2.903h1.523l-1.329-6.02Zm-2.013 3.89c.136-.347.654-1.684.654-1.684-.01.016.135-.349.218-.575l.11.52.381 1.739h-1.363ZM7.628 9.014 6.02 13.122l-.171-.835c-.3-.962-1.232-2.005-2.274-2.527l1.47 5.268 1.737-.002 2.585-6.012h-1.74"
      />
      <path
        fill="#F2AE14"
        d="M4.52 9.014H1.874l-.02.126c2.059.498 3.422 1.703 3.988 3.15l-.576-2.767c-.1-.382-.388-.496-.744-.509"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);

export const MastercardIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <path fill="#FF5F00" d="M9.296 7.283h5.408v9.433H9.296V7.284Z" />
    <path
      fill="#EB001B"
      d="M9.64 12c0-1.917.926-3.617 2.351-4.717A6.26 6.26 0 0 0 8.181 6C4.763 6 2 8.683 2 12s2.764 6 6.18 6a6.26 6.26 0 0 0 3.811-1.283A5.93 5.93 0 0 1 9.64 12Z"
    />
    <path
      fill="#F79E1B"
      d="M22 12c0 3.317-2.764 6-6.18 6a6.26 6.26 0 0 1-3.812-1.283c1.443-1.1 2.353-2.8 2.353-4.717 0-1.917-.928-3.617-2.353-4.717A6.26 6.26 0 0 1 15.82 6C19.236 6 22 8.7 22 12Z"
    />
  </svg>
);

export const TrashIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.56}
        d="M5.833 17.5c-.458 0-.85-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.177V5a.806.806 0 0 1-.593-.24.806.806 0 0 1-.24-.593c0-.236.08-.434.24-.594.16-.16.358-.24.594-.24H7.5c0-.236.08-.434.24-.593.16-.16.357-.24.593-.24h3.334c.236 0 .434.08.594.24.16.16.239.357.239.593h3.333c.237 0 .434.08.594.24.16.16.24.358.24.594s-.08.434-.24.593a.806.806 0 0 1-.594.24v10.833c0 .459-.163.851-.49 1.177-.326.327-.718.49-1.176.49H5.833Zm0-12.5v10.833h8.334V5H5.833ZM7.5 13.333c0 .236.08.434.24.594.16.16.357.24.593.24s.434-.08.594-.24c.16-.16.24-.358.24-.594V7.5a.806.806 0 0 0-.24-.594.806.806 0 0 0-.594-.24.806.806 0 0 0-.593.24.806.806 0 0 0-.24.594v5.833Zm3.333 0c0 .236.08.434.24.594.16.16.358.24.594.24s.434-.08.594-.24c.16-.16.239-.358.239-.594V7.5a.806.806 0 0 0-.24-.594.807.807 0 0 0-.593-.24.806.806 0 0 0-.594.24.806.806 0 0 0-.24.594v5.833Z"
      />
    </g>
  </svg>
);

export const EmptyCompanyIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={13}
    height={16}
    fill="none"
    {...props}
  >
    <g fill="#302F2E" fillOpacity={0.56}>
      <path d="M5.909.052a8.246 8.246 0 0 0-.698-.05H3.087c3.726.084 7.39 2.764 7.39 8 0 5.235-3.637 7.893-7.346 7.996h2.1c3.708-.106 7.34-2.785 7.34-7.997 0-4.897-3.204-7.554-6.665-7.95h.003Z" />
      <path d="M8.12 7.999c0-3.694-1.623-6.113-4.005-7.248A7.826 7.826 0 0 0 .75 0v.749c2.463 0 4.892 2.429 4.892 7.25 0 4.82-2.429 7.215-4.892 7.215V16c1.186 0 2.37-.263 3.44-.786 2.346-1.15 3.933-3.558 3.933-7.213L8.12 8Z" />
    </g>
  </svg>
);

export const LogDetailsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g opacity={0.8}>
      <mask
        id="a"
        width={18}
        height={18}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha"
        }}
      >
        <path fill="#D9D9D9" d="M0 0h18v18H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#114B5B"
          d="M6 6.75c.213 0 .39-.072.534-.216A.726.726 0 0 0 6.75 6a.726.726 0 0 0-.216-.534A.726.726 0 0 0 6 5.25a.726.726 0 0 0-.534.216A.726.726 0 0 0 5.25 6c0 .213.072.39.216.534A.726.726 0 0 0 6 6.75Zm0 3c.213 0 .39-.072.534-.216A.726.726 0 0 0 6.75 9a.726.726 0 0 0-.216-.534A.726.726 0 0 0 6 8.25a.726.726 0 0 0-.534.216A.726.726 0 0 0 5.25 9c0 .213.072.39.216.534A.726.726 0 0 0 6 9.75Zm0 3c.213 0 .39-.072.534-.216A.726.726 0 0 0 6.75 12a.726.726 0 0 0-.216-.534A.726.726 0 0 0 6 11.25a.726.726 0 0 0-.534.216.726.726 0 0 0-.216.534c0 .213.072.39.216.534A.726.726 0 0 0 6 12.75Zm-2.25 3c-.413 0-.766-.147-1.06-.44a1.445 1.445 0 0 1-.44-1.06V3.75c0-.413.147-.766.44-1.06.294-.293.647-.44 1.06-.44h7.631a1.48 1.48 0 0 1 1.05.431L15.32 5.57a1.481 1.481 0 0 1 .431 1.05v7.631c0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44H3.75Zm0-1.5h10.5v-7.5H12a.726.726 0 0 1-.534-.216A.726.726 0 0 1 11.25 6V3.75h-7.5v10.5Z"
        />
      </g>
    </g>
  </svg>
);

export const CancelledIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#EF5B1B"
        d="M5.875 14.125a.806.806 0 0 1-.25-.59c0-.225.083-.422.25-.589L8.821 10 5.875 7.054a.806.806 0 0 1-.25-.59c0-.225.083-.422.25-.589a.806.806 0 0 1 .59-.25c.225 0 .422.083.589.25L10 8.822l2.946-2.947a.806.806 0 0 1 .59-.25c.225 0 .422.083.589.25.167.167.25.364.25.59a.807.807 0 0 1-.25.589L11.178 10l2.947 2.946c.167.167.25.364.25.59a.807.807 0 0 1-.25.589.807.807 0 0 1-.59.25.806.806 0 0 1-.589-.25L10 11.179l-2.946 2.946a.806.806 0 0 1-.59.25.807.807 0 0 1-.589-.25Z"
      />
    </g>
  </svg>
);

export const CheckIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.38}
        d="m8.333 11.333 4.917-4.916a.79.79 0 0 1 .583-.23.79.79 0 0 1 .583.23.79.79 0 0 1 .23.583.79.79 0 0 1-.23.583l-5.5 5.5a.8.8 0 0 1-.583.25.8.8 0 0 1-.583-.25l-2.167-2.166a.79.79 0 0 1-.229-.584.79.79 0 0 1 .23-.583.79.79 0 0 1 .583-.23.79.79 0 0 1 .583.23l1.583 1.583Z"
      />
    </g>
  </svg>
);

export const TransactionsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g opacity={0.8}>
      <mask
        id="a"
        width={18}
        height={18}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha"
        }}
      >
        <path fill="#D9D9D9" d="M0 0h18v18H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#114B5B"
          d="M9.113 12.113c.412 0 .765-.097 1.059-.291.294-.194.44-.497.44-.91 0-.362-.153-.656-.459-.88-.306-.226-.853-.482-1.64-.77C7.774 9 7.233 8.688 6.89 8.325c-.344-.362-.516-.837-.516-1.425 0-.513.178-.978.534-1.397.357-.419.841-.69 1.454-.816v-.28a.63.63 0 0 1 .196-.46.63.63 0 0 1 .46-.197.63.63 0 0 1 .46.197.63.63 0 0 1 .196.46v.28c.362.026.697.147 1.003.366.306.219.553.484.74.797a.428.428 0 0 1 .02.44.632.632 0 0 1-.376.329.746.746 0 0 1-.881-.263 1.438 1.438 0 0 0-.468-.365 1.495 1.495 0 0 0-.675-.141c-.438 0-.772.094-1.004.281-.23.188-.347.444-.347.769s.144.581.432.769c.287.187.806.406 1.556.656.9.325 1.5.706 1.8 1.144.3.437.45.918.45 1.444 0 .362-.063.68-.188.956-.124.275-.29.51-.496.703-.207.194-.447.35-.722.469-.275.118-.569.209-.882.271v.282a.63.63 0 0 1-.196.46.63.63 0 0 1-.46.196.63.63 0 0 1-.46-.197.63.63 0 0 1-.196-.46v-.318a2.812 2.812 0 0 1-1.219-.563 2.951 2.951 0 0 1-.806-1.05.576.576 0 0 1 .01-.506.662.662 0 0 1 .384-.337.629.629 0 0 1 .487.01.77.77 0 0 1 .375.327c.175.325.397.566.666.722.269.156.566.235.89.235ZM9 17.25c-1.4 0-2.688-.319-3.862-.956a8.36 8.36 0 0 1-2.888-2.55V15c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216.726.726 0 0 1-.534-.216A.726.726 0 0 1 .75 15v-3c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.216h3c.213 0 .39.072.534.216A.726.726 0 0 1 5.25 12c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216H3.394c.6.9 1.39 1.625 2.372 2.175.98.55 2.059.825 3.234.825 1.762 0 3.278-.588 4.547-1.762 1.269-1.175 1.99-2.62 2.165-4.332.026-.2.113-.36.263-.478A.821.821 0 0 1 16.5 9c.212 0 .394.066.544.197.15.131.212.29.187.478a8.006 8.006 0 0 1-.825 2.972 8.343 8.343 0 0 1-4.34 4.012A7.972 7.972 0 0 1 9 17.25Zm0-15c-1.763 0-3.278.587-4.547 1.763-1.269 1.175-1.99 2.618-2.166 4.33a.695.695 0 0 1-.262.479A.821.821 0 0 1 1.5 9a.797.797 0 0 1-.544-.197.514.514 0 0 1-.187-.478 8.006 8.006 0 0 1 .825-2.972 8.344 8.344 0 0 1 4.34-4.012A7.972 7.972 0 0 1 9 .75c1.4 0 2.688.319 3.863.956a8.358 8.358 0 0 1 2.887 2.55V3c0-.212.072-.39.216-.534a.726.726 0 0 1 .534-.216c.212 0 .39.072.534.216A.726.726 0 0 1 17.25 3v3c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216h-3a.726.726 0 0 1-.534-.216A.726.726 0 0 1 12.75 6c0-.213.072-.39.216-.534a.726.726 0 0 1 .534-.216h1.106c-.6-.9-1.39-1.625-2.372-2.175-.98-.55-2.059-.825-3.234-.825Z"
        />
      </g>
    </g>
  </svg>
);

export const PlatformSettingsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g opacity={0.8}>
      <mask
        id="a"
        width={18}
        height={18}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha"
        }}
      >
        <path fill="#D9D9D9" d="M0 0h18v18H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#114B5B"
          d="M3 14.25a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.39.216-.534A.726.726 0 0 1 3 12.75h3c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.39-.216.534A.726.726 0 0 1 6 14.25H3Zm0-9a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.534c0-.213.072-.39.216-.534A.726.726 0 0 1 3 3.75h6c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.39-.216.534A.726.726 0 0 1 9 5.25H3Zm6 10.5a.726.726 0 0 1-.534-.216A.726.726 0 0 1 8.25 15v-3c0-.213.072-.39.216-.534A.726.726 0 0 1 9 11.25c.213 0 .39.072.534.216A.726.726 0 0 1 9.75 12v.75H15c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.39-.216.534a.726.726 0 0 1-.534.216H9.75V15c0 .213-.072.39-.216.534A.726.726 0 0 1 9 15.75Zm-3-4.5a.726.726 0 0 1-.534-.216.726.726 0 0 1-.216-.534v-.75H3a.726.726 0 0 1-.534-.216A.726.726 0 0 1 2.25 9c0-.213.072-.39.216-.534A.726.726 0 0 1 3 8.25h2.25V7.5c0-.213.072-.39.216-.534A.726.726 0 0 1 6 6.75c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534v3c0 .213-.072.39-.216.534A.726.726 0 0 1 6 11.25Zm3-1.5a.726.726 0 0 1-.534-.216A.726.726 0 0 1 8.25 9c0-.213.072-.39.216-.534A.726.726 0 0 1 9 8.25h6c.213 0 .39.072.534.216A.726.726 0 0 1 15.75 9c0 .213-.072.39-.216.534A.726.726 0 0 1 15 9.75H9Zm3-3a.726.726 0 0 1-.534-.216A.726.726 0 0 1 11.25 6V3c0-.212.072-.39.216-.534A.726.726 0 0 1 12 2.25c.213 0 .39.072.534.216A.726.726 0 0 1 12.75 3v.75H15c.213 0 .39.072.534.216a.726.726 0 0 1 .216.534c0 .213-.072.39-.216.534A.726.726 0 0 1 15 5.25h-2.25V6c0 .213-.072.39-.216.534A.726.726 0 0 1 12 6.75Z"
        />
      </g>
    </g>
  </svg>
);

export const OrderDetailsIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g opacity={0.8}>
      <mask
        id="a"
        width={18}
        height={18}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha"
        }}
      >
        <path fill="#D9D9D9" d="M0 0h18v18H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#114B5B"
          d="M3.75 16.5c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 0 1 2.25 15V6c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h1.5c0-1.038.366-1.922 1.097-2.653A3.614 3.614 0 0 1 9 .75c1.037 0 1.922.366 2.653 1.097.731.731 1.097 1.615 1.097 2.653h1.5c.412 0 .766.147 1.06.44.293.294.44.647.44 1.06v9c0 .412-.147.766-.44 1.06-.294.293-.648.44-1.06.44H3.75Zm0-1.5h10.5V6H3.75v9ZM9 10.5c1.037 0 1.922-.366 2.653-1.097.731-.731 1.097-1.616 1.097-2.653h-1.5a2.17 2.17 0 0 1-.656 1.594A2.17 2.17 0 0 1 9 9a2.17 2.17 0 0 1-1.594-.656A2.17 2.17 0 0 1 6.75 6.75h-1.5c0 1.037.366 1.922 1.097 2.653C7.078 10.134 7.962 10.5 9 10.5Zm-2.25-6h4.5a2.17 2.17 0 0 0-.656-1.594A2.17 2.17 0 0 0 9 2.25a2.17 2.17 0 0 0-1.594.656A2.17 2.17 0 0 0 6.75 4.5Z"
        />
      </g>
    </g>
  </svg>
);

export const OrderAmountIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={40}
    height={40}
    fill="none"
    {...props}
  >
    <rect width={40} height={40} fill="#F6F4F1" rx={20} />
    <path
      fill="#302F2E"
      fillOpacity={0.56}
      d="M22.46 19.29c-.29-.21-.63-.37-1-.49s-.74-.23-1.11-.33v-2.44c.33 0 .61.05.82.16.21.1.38.24.51.39.13.16.22.33.28.5.06.18.11.33.14.47h.53c.05-.32.11-.63.16-.94.05-.31.12-.61.2-.92-.24-.12-.47-.22-.66-.31-.2-.09-.4-.16-.6-.21-.2-.05-.41-.1-.62-.13-.22-.03-.46-.05-.75-.06 0-.17 0-.34.01-.5 0-.16.02-.33.04-.49-.14.03-.29.04-.45.04-.16 0-.32-.01-.5-.04.02.18.03.35.03.5v.5c-.43.05-.83.16-1.2.32s-.68.37-.94.62c-.26.26-.46.57-.6.93-.14.36-.22.77-.22 1.23 0 .46.06.84.18 1.17.12.33.27.6.46.82.19.22.4.4.64.53s.48.23.72.31l.93.27v2.41c-.43-.05-.76-.13-1.01-.25s-.44-.26-.58-.42c-.14-.16-.23-.32-.29-.49-.06-.17-.11-.33-.14-.46h-.53c-.05.32-.09.64-.14.96-.05.32-.12.64-.2.96.41.21.84.38 1.3.51.46.13.99.21 1.59.24 0 .23 0 .45-.01.68 0 .23-.02.45-.03.68.16-.03.32-.04.49-.04.08 0 .16 0 .24.01.08 0 .15.02.22.03-.02-.24-.03-.46-.04-.68 0-.22-.01-.45-.01-.68.97-.09 1.73-.39 2.29-.9s.84-1.27.84-2.29c0-.54-.09-.99-.28-1.33-.19-.34-.43-.62-.72-.83l.01-.01Zm-2.96-1.04c-.08-.03-.18-.06-.31-.11-.12-.05-.24-.11-.35-.19-.11-.08-.21-.18-.29-.31a.864.864 0 0 1-.12-.47c0-.21.04-.38.12-.52.08-.14.18-.24.3-.33.12-.08.24-.14.35-.18.12-.04.22-.07.3-.09v2.2ZM21.37 23c-.06.12-.15.22-.25.31-.1.08-.22.14-.36.19-.14.04-.28.09-.43.12v-2.2c.15.05.3.11.44.16s.26.12.37.2c.1.08.19.18.24.3.06.12.09.27.09.46s-.03.35-.1.47V23Z"
    />
    <path
      fill="#302F2E"
      fillOpacity={0.56}
      d="M29 18.61a9 9 0 0 0-18 0c0 .47.05.93.12 1.39-.07.45-.12.91-.12 1.39a9 9 0 0 0 18 0c0-.47-.05-.93-.12-1.39.07-.45.12-.91.12-1.39Zm-9 8.78c-4.42 0-8.08-3.19-8.84-7.39.76-4.2 4.42-7.39 8.84-7.39s8.08 3.19 8.84 7.39c-.76 4.2-4.42 7.39-8.84 7.39Z"
    />
    <rect
      width={39}
      height={39}
      x={0.5}
      y={0.5}
      stroke="#302F2E"
      strokeOpacity={0.15}
      rx={19.5}
    />
  </svg>
);

export const PaidUpfrontOrderIcon = (props: any) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#229AB9" />
    <path
      d="M18 22.175L23.9 16.275C24.0834 16.0917 24.3167 16 24.6 16C24.8834 16 25.1167 16.0917 25.3 16.275C25.4834 16.4583 25.575 16.6917 25.575 16.975C25.575 17.2583 25.4834 17.4917 25.3 17.675L18.7 24.275C18.5 24.475 18.2667 24.575 18 24.575C17.7334 24.575 17.5 24.475 17.3 24.275L14.7 21.675C14.5167 21.4917 14.425 21.2583 14.425 20.975C14.425 20.6917 14.5167 20.4583 14.7 20.275C14.8834 20.0917 15.1167 20 15.4 20C15.6834 20 15.9167 20.0917 16.1 20.275L18 22.175Z"
      fill="#FDFEFE"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 28C24.4183 28 28 24.4183 28 20C28 15.5817 24.4183 12 20 12C15.5817 12 12 15.5817 12 20C12 24.4183 15.5817 28 20 28ZM20 30C25.5228 30 30 25.5228 30 20C30 14.4772 25.5228 10 20 10C14.4772 10 10 14.4772 10 20C10 25.5228 14.4772 30 20 30Z"
      fill="#FDFEFE"
    />
  </svg>
);

export const PartialPaymentOrderIcon = (props: any) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#229AB9" />
    <mask
      id="mask0_1871_63318"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="24"
      height="24"
    >
      <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1871_63318)">
      <path
        d="M23 28C20.7667 28 18.875 27.225 17.325 25.675C15.775 24.125 15 22.2333 15 20C15 17.7667 15.775 15.875 17.325 14.325C18.875 12.775 20.7667 12 23 12C25.2333 12 27.125 12.775 28.675 14.325C30.225 15.875 31 17.7667 31 20C31 22.2333 30.225 24.125 28.675 25.675C27.125 27.225 25.2333 28 23 28ZM13.625 27.25C12.225 26.6 11.1042 25.625 10.2625 24.325C9.42083 23.025 9 21.5833 9 20C9 18.4167 9.42083 16.975 10.2625 15.675C11.1042 14.375 12.225 13.4 13.625 12.75C13.975 12.5833 14.2917 12.5958 14.575 12.7875C14.8583 12.9792 15 13.2917 15 13.725C15 13.8917 14.9458 14.0542 14.8375 14.2125C14.7292 14.3708 14.5917 14.4917 14.425 14.575C13.375 15.0583 12.5417 15.7875 11.925 16.7625C11.3083 17.7375 11 18.8167 11 20C11 21.1833 11.3083 22.2625 11.925 23.2375C12.5417 24.2125 13.375 24.9417 14.425 25.425C14.5917 25.5083 14.7292 25.625 14.8375 25.775C14.9458 25.925 15 26.0917 15 26.275C15 26.6917 14.8583 27 14.575 27.2C14.2917 27.4 13.975 27.4167 13.625 27.25ZM23 26C24.6667 26 26.0833 25.4167 27.25 24.25C28.4167 23.0833 29 21.6667 29 20C29 18.3333 28.4167 16.9167 27.25 15.75C26.0833 14.5833 24.6667 14 23 14C21.3333 14 19.9167 14.5833 18.75 15.75C17.5833 16.9167 17 18.3333 17 20C17 21.6667 17.5833 23.0833 18.75 24.25C19.9167 25.4167 21.3333 26 23 26Z"
        fill="#FDFEFE"
      />
    </g>
  </svg>
);

export const FullyPaidOrderIcon = (props: any) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#0A8463" />
    <mask
      id="mask0_1871_64313"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="24"
      height="24"
    >
      <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1871_64313)">
      <path
        d="M18 21.5998L23.9 15.6998C24.0833 15.5165 24.3167 15.4248 24.6 15.4248C24.8833 15.4248 25.1167 15.5165 25.3 15.6998C25.4833 15.8831 25.575 16.1165 25.575 16.3998C25.575 16.6831 25.4833 16.9165 25.3 17.0998L18.7 23.6998C18.5 23.8998 18.2667 23.9998 18 23.9998C17.7333 23.9998 17.5 23.8998 17.3 23.6998L14.7 21.0998C14.5167 20.9165 14.425 20.6831 14.425 20.3998C14.425 20.1165 14.5167 19.8831 14.7 19.6998C14.8833 19.5165 15.1167 19.4248 15.4 19.4248C15.6833 19.4248 15.9167 19.5165 16.1 19.6998L18 21.5998Z"
        fill="#FDFEFD"
      />
    </g>
  </svg>
);

export const FailedOrderIcon = (props: any) => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#EF5B1B" />
    <mask
      id="mask0_1930_70584"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="25"
      height="24"
    >
      <rect x="8.5" y="8" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1930_70584)">
      <path
        d="M20.5 22C20.2167 22 19.9792 21.9042 19.7875 21.7125C19.5958 21.5208 19.5 21.2833 19.5 21V14C19.5 13.7167 19.5958 13.4792 19.7875 13.2875C19.9792 13.0958 20.2167 13 20.5 13C20.7833 13 21.0208 13.0958 21.2125 13.2875C21.4042 13.4792 21.5 13.7167 21.5 14V21C21.5 21.2833 21.4042 21.5208 21.2125 21.7125C21.0208 21.9042 20.7833 22 20.5 22ZM20.5 27C20.2167 27 19.9792 26.9042 19.7875 26.7125C19.5958 26.5208 19.5 26.2833 19.5 26C19.5 25.7167 19.5958 25.4792 19.7875 25.2875C19.9792 25.0958 20.2167 25 20.5 25C20.7833 25 21.0208 25.0958 21.2125 25.2875C21.4042 25.4792 21.5 25.7167 21.5 26C21.5 26.2833 21.4042 26.5208 21.2125 26.7125C21.0208 26.9042 20.7833 27 20.5 27Z"
        fill="#FFFDFD"
      />
    </g>
  </svg>
);

export const CancelledOrderIcon = (props: any) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#EF5B1B" />
    <mask
      id="mask0_1871_67146"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="24"
      height="24"
    >
      <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1871_67146)">
      <path
        d="M15.0503 24.9498C14.8499 24.7495 14.7497 24.5138 14.7497 24.2427C14.7497 23.9717 14.8499 23.736 15.0503 23.5356L18.5858 20.0001L15.0503 16.4645C14.8499 16.2642 14.7497 16.0285 14.7497 15.7574C14.7497 15.4864 14.8499 15.2507 15.0503 15.0503C15.2506 14.85 15.4863 14.7498 15.7574 14.7498C16.0284 14.7498 16.2641 14.85 16.4645 15.0503L20 18.5859L23.5355 15.0503C23.7359 14.85 23.9716 14.7498 24.2426 14.7498C24.5137 14.7498 24.7494 14.85 24.9497 15.0503C25.1501 15.2507 25.2503 15.4864 25.2503 15.7574C25.2503 16.0285 25.1501 16.2642 24.9497 16.4645L21.4142 20.0001L24.9497 23.5356C25.1501 23.736 25.2503 23.9717 25.2503 24.2427C25.2503 24.5138 25.1501 24.7495 24.9497 24.9498C24.7494 25.1502 24.5137 25.2503 24.2426 25.2503C23.9716 25.2503 23.7359 25.1502 23.5355 24.9498L20 21.4143L16.4645 24.9498C16.2641 25.1502 16.0284 25.2503 15.7574 25.2503C15.4863 25.2503 15.2506 25.1502 15.0503 24.9498Z"
        fill="#FFFDFD"
      />
    </g>
  </svg>
);

export const PayInStoreOrderIcon = (props: any) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#229AB9" />
    <mask
      id="mask0_2450_67671"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="24"
      height="24"
    >
      <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2450_67671)">
      <path
        d="M13.025 29C12.475 29 12.0041 28.8042 11.6125 28.4125C11.2208 28.0208 11.025 27.55 11.025 27V19.05C10.6416 18.7 10.3458 18.25 10.1375 17.7C9.92913 17.15 9.92497 16.55 10.125 15.9L11.175 12.5C11.3083 12.0667 11.5458 11.7083 11.8875 11.425C12.2291 11.1417 12.625 11 13.075 11H26.975C27.425 11 27.8166 11.1375 28.15 11.4125C28.4833 11.6875 28.725 12.05 28.875 12.5L29.925 15.9C30.125 16.55 30.1208 17.1417 29.9125 17.675C29.7041 18.2083 29.4083 18.6667 29.025 19.05V27C29.025 27.55 28.8291 28.0208 28.4375 28.4125C28.0458 28.8042 27.575 29 27.025 29H13.025ZM22.225 18C22.675 18 23.0166 17.8458 23.25 17.5375C23.4833 17.2292 23.575 16.8833 23.525 16.5L22.975 13H21.025V16.7C21.025 17.05 21.1416 17.3542 21.375 17.6125C21.6083 17.8708 21.8916 18 22.225 18ZM17.725 18C18.1083 18 18.4208 17.8708 18.6625 17.6125C18.9041 17.3542 19.025 17.05 19.025 16.7V13H17.075L16.525 16.5C16.4583 16.9 16.5458 17.25 16.7875 17.55C17.0291 17.85 17.3416 18 17.725 18ZM13.275 18C13.575 18 13.8375 17.8917 14.0625 17.675C14.2875 17.4583 14.425 17.1833 14.475 16.85L15.025 13H13.075L12.075 16.35C11.975 16.6833 12.0291 17.0417 12.2375 17.425C12.4458 17.8083 12.7916 18 13.275 18ZM26.775 18C27.2583 18 27.6083 17.8083 27.825 17.425C28.0416 17.0417 28.0916 16.6833 27.975 16.35L26.925 13H25.025L25.575 16.85C25.625 17.1833 25.7625 17.4583 25.9875 17.675C26.2125 17.8917 26.475 18 26.775 18ZM13.025 27H27.025V19.95C26.9416 19.9833 26.8875 20 26.8625 20H26.775C26.325 20 25.9291 19.925 25.5875 19.775C25.2458 19.625 24.9083 19.3833 24.575 19.05C24.275 19.35 23.9333 19.5833 23.55 19.75C23.1666 19.9167 22.7583 20 22.325 20C21.875 20 21.4541 19.9167 21.0625 19.75C20.6708 19.5833 20.325 19.35 20.025 19.05C19.7416 19.35 19.4125 19.5833 19.0375 19.75C18.6625 19.9167 18.2583 20 17.825 20C17.3416 20 16.9041 19.9167 16.5125 19.75C16.1208 19.5833 15.775 19.35 15.475 19.05C15.125 19.4 14.7791 19.6458 14.4375 19.7875C14.0958 19.9292 13.7083 20 13.275 20H13.1625C13.1208 20 13.075 19.9833 13.025 19.95V27Z"
        fill="#FDFEFE"
      />
    </g>
  </svg>
);

export const RefundedOrderIcon = (props: any) => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="40" height="40" rx="20" fill="#FFA344" />
    <mask
      id="mask0_1871_67857"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="24"
      height="24"
    >
      <rect x="8" y="8" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1871_67857)">
      <path
        d="M16.2998 25.2999L11.6998 20.6999C11.5998 20.5999 11.529 20.4916 11.4873 20.3749C11.4456 20.2582 11.4248 20.1332 11.4248 19.9999C11.4248 19.8666 11.4456 19.7416 11.4873 19.6249C11.529 19.5082 11.5998 19.3999 11.6998 19.2999L16.3248 14.6749C16.5081 14.4916 16.7331 14.3999 16.9998 14.3999C17.2665 14.3999 17.4998 14.4999 17.6998 14.6999C17.8831 14.8832 17.9748 15.1166 17.9748 15.3999C17.9748 15.6832 17.8831 15.9166 17.6998 16.0999L14.7998 18.9999H27.9998C28.2831 18.9999 28.5206 19.0957 28.7123 19.2874C28.904 19.4791 28.9998 19.7166 28.9998 19.9999C28.9998 20.2832 28.904 20.5207 28.7123 20.7124C28.5206 20.9041 28.2831 20.9999 27.9998 20.9999H14.7998L17.7248 23.9249C17.9081 24.1082 17.9998 24.3332 17.9998 24.5999C17.9998 24.8666 17.8998 25.0999 17.6998 25.2999C17.5165 25.4832 17.2831 25.5749 16.9998 25.5749C16.7165 25.5749 16.4831 25.4832 16.2998 25.2999Z"
        fill="#FFFAF5"
      />
    </g>
  </svg>
);

export const RefundedOrderButtonIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#66411B"
        d="m6.917 14.417-3.834-3.834a.732.732 0 0 1-.177-.27.922.922 0 0 1-.052-.313c0-.111.017-.215.052-.313a.731.731 0 0 1 .177-.27l3.854-3.855a.765.765 0 0 1 .563-.229.8.8 0 0 1 .583.25.79.79 0 0 1 .23.584.79.79 0 0 1-.23.583L5.666 9.167h11c.237 0 .434.08.594.24.16.159.24.357.24.593s-.08.434-.24.594a.807.807 0 0 1-.594.24h-11l2.438 2.437c.153.152.23.34.23.562a.8.8 0 0 1-.25.584.79.79 0 0 1-.584.229.79.79 0 0 1-.583-.23Z"
      />
    </g>
  </svg>
);

export const DefaultAvatarIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill="#F6F4F1"
      d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4Zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4Z"
    />
  </svg>
);

export const PlusIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <mask
      id="a"
      width={24}
      height={24}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha"
      }}
    >
      <path fill="#D9D9D9" d="M0 0h24v24H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="#302F2E"
        fillOpacity={0.95}
        d="M12 19a.968.968 0 0 1-.713-.288A.968.968 0 0 1 11 18v-5H6a.967.967 0 0 1-.713-.287A.968.968 0 0 1 5 12c0-.283.096-.52.287-.713A.967.967 0 0 1 6 11h5V6c0-.283.096-.52.287-.713A.968.968 0 0 1 12 5c.283 0 .52.096.713.287.191.192.287.43.287.713v5h5c.283 0 .52.096.712.287.192.192.288.43.288.713s-.096.52-.288.713A.968.968 0 0 1 18 13h-5v5c0 .283-.096.52-.287.712A.968.968 0 0 1 12 19Z"
      />
    </g>
  </svg>
);

export const TimeoutOrderIcon = (props: any) => (
  <svg
    width="41"
    height="40"
    viewBox="0 0 41 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="0.5" width="40" height="40" rx="20" fill="#FFA344" />
    <mask
      id="mask0_1930_69962"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="8"
      y="8"
      width="25"
      height="24"
    >
      <rect x="8.5" y="8" width="24" height="24" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_1930_69962)">
      <path
        d="M21.4998 19.5998L24.4998 22.5998C24.6831 22.7831 24.7748 23.0165 24.7748 23.2998C24.7748 23.5831 24.6831 23.8165 24.4998 23.9998C24.3165 24.1831 24.0831 24.2748 23.7998 24.2748C23.5165 24.2748 23.2831 24.1831 23.0998 23.9998L19.7998 20.6998C19.6998 20.5998 19.6248 20.4873 19.5748 20.3623C19.5248 20.2373 19.4998 20.1081 19.4998 19.9748V15.9998C19.4998 15.7165 19.5956 15.479 19.7873 15.2873C19.979 15.0956 20.2165 14.9998 20.4998 14.9998C20.7831 14.9998 21.0206 15.0956 21.2123 15.2873C21.404 15.479 21.4998 15.7165 21.4998 15.9998V19.5998ZM11.3498 24.0748C11.1331 23.5915 10.9581 23.0915 10.8248 22.5748C10.6915 22.0581 10.5998 21.5331 10.5498 20.9998H12.5748C12.6248 21.3498 12.6956 21.6998 12.7873 22.0498C12.879 22.3998 12.9915 22.7415 13.1248 23.0748L11.3498 24.0748ZM10.5498 18.9998C10.5998 18.4665 10.6915 17.9373 10.8248 17.4123C10.9581 16.8873 11.1415 16.3831 11.3748 15.8998L13.1248 16.8998C12.9915 17.2331 12.879 17.5748 12.7873 17.9248C12.6956 18.2748 12.6248 18.6331 12.5748 18.9998H10.5498ZM14.6748 28.1498C14.2248 27.8165 13.8081 27.454 13.4248 27.0623C13.0415 26.6706 12.6831 26.2498 12.3498 25.7998L14.0998 24.7998C14.3331 25.0998 14.579 25.379 14.8373 25.6373C15.0956 25.8956 15.3748 26.1415 15.6748 26.3748L14.6748 28.1498ZM14.1248 15.1748L12.3498 14.1748C12.6831 13.7248 13.0415 13.3081 13.4248 12.9248C13.8081 12.5415 14.2248 12.1831 14.6748 11.8498L15.6748 13.6248C15.3915 13.8581 15.1206 14.104 14.8623 14.3623C14.604 14.6206 14.3581 14.8915 14.1248 15.1748ZM19.4998 29.9498C18.9665 29.8998 18.4373 29.8081 17.9123 29.6748C17.3873 29.5415 16.8831 29.3581 16.3998 29.1248L17.3998 27.3748C17.7331 27.5081 18.0748 27.6206 18.4248 27.7123C18.7748 27.804 19.1331 27.8748 19.4998 27.9248V29.9498ZM17.3998 12.6248L16.3998 10.8748C16.8831 10.6415 17.3873 10.4581 17.9123 10.3248C18.4373 10.1915 18.9665 10.0998 19.4998 10.0498V12.0748C19.1331 12.1248 18.7748 12.1956 18.4248 12.2873C18.0748 12.379 17.7331 12.4915 17.3998 12.6248ZM21.4998 29.9498V27.9248C21.8665 27.8748 22.2248 27.804 22.5748 27.7123C22.9248 27.6206 23.2665 27.5081 23.5998 27.3748L24.5998 29.1248C24.1165 29.3581 23.6123 29.5415 23.0873 29.6748C22.5623 29.8081 22.0331 29.8998 21.4998 29.9498ZM23.5998 12.6248C23.2665 12.4915 22.9248 12.379 22.5748 12.2873C22.2248 12.1956 21.8665 12.1248 21.4998 12.0748V10.0498C22.0331 10.0998 22.5623 10.1915 23.0873 10.3248C23.6123 10.4581 24.1165 10.6415 24.5998 10.8748L23.5998 12.6248ZM26.3248 28.1498L25.3248 26.3748C25.6081 26.1415 25.879 25.8956 26.1373 25.6373C26.3956 25.379 26.6415 25.1081 26.8748 24.8248L28.6498 25.8248C28.3165 26.2748 27.9581 26.6956 27.5748 27.0873C27.1915 27.479 26.7748 27.8331 26.3248 28.1498ZM26.8748 15.1748C26.6415 14.8915 26.3956 14.6206 26.1373 14.3623C25.879 14.104 25.6081 13.8581 25.3248 13.6248L26.3248 11.8498C26.7748 12.1665 27.1915 12.5165 27.5748 12.8998C27.9581 13.2831 28.3081 13.6998 28.6248 14.1498L26.8748 15.1748ZM28.4248 18.9998C28.3748 18.6331 28.304 18.2748 28.2123 17.9248C28.1206 17.5748 28.0081 17.2331 27.8748 16.8998L29.6248 15.8748C29.8415 16.3748 30.0206 16.8873 30.1623 17.4123C30.304 17.9373 30.3998 18.4665 30.4498 18.9998H28.4248ZM29.6248 24.0998L27.8748 23.0998C28.0081 22.7665 28.1206 22.4248 28.2123 22.0748C28.304 21.7248 28.3748 21.3665 28.4248 20.9998H30.4498C30.3998 21.5331 30.3081 22.0623 30.1748 22.5873C30.0415 23.1123 29.8581 23.6165 29.6248 24.0998Z"
        fill="#FFFAF5"
      />
    </g>
  </svg>
);

export const AddOnsDetailsIcon = (props: any) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2892_38766"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="18"
      height="18"
    >
      <rect width="18" height="18" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_2892_38766)">
      <path
        d="M9 10.8563L10.425 11.7188C10.5625 11.8062 10.7 11.8031 10.8375 11.7094C10.975 11.6156 11.025 11.4875 10.9875 11.325L10.6125 9.69375L11.8875 8.5875C12.0125 8.475 12.05 8.34063 12 8.18438C11.95 8.02813 11.8375 7.94375 11.6625 7.93125L9.99375 7.8L9.3375 6.2625C9.275 6.1125 9.1625 6.0375 9 6.0375C8.8375 6.0375 8.725 6.1125 8.6625 6.2625L8.00625 7.8L6.3375 7.93125C6.1625 7.94375 6.05 8.02813 6 8.18438C5.95 8.34063 5.9875 8.475 6.1125 8.5875L7.3875 9.69375L7.0125 11.325C6.975 11.4875 7.025 11.6156 7.1625 11.7094C7.3 11.8031 7.4375 11.8062 7.575 11.7188L9 10.8563ZM6.4875 15H4.5C4.0875 15 3.73438 14.8531 3.44063 14.5594C3.14688 14.2656 3 13.9125 3 13.5V11.5125L1.55625 10.05C1.41875 9.9 1.3125 9.73438 1.2375 9.55313C1.1625 9.37187 1.125 9.1875 1.125 9C1.125 8.8125 1.1625 8.62812 1.2375 8.44687C1.3125 8.26562 1.41875 8.1 1.55625 7.95L3 6.4875V4.5C3 4.0875 3.14688 3.73438 3.44063 3.44063C3.73438 3.14688 4.0875 3 4.5 3H6.4875L7.95 1.55625C8.1 1.41875 8.26562 1.3125 8.44687 1.2375C8.62812 1.1625 8.8125 1.125 9 1.125C9.1875 1.125 9.37187 1.1625 9.55313 1.2375C9.73438 1.3125 9.9 1.41875 10.05 1.55625L11.5125 3H13.5C13.9125 3 14.2656 3.14688 14.5594 3.44063C14.8531 3.73438 15 4.0875 15 4.5V6.4875L16.4438 7.95C16.5813 8.1 16.6875 8.26562 16.7625 8.44687C16.8375 8.62812 16.875 8.8125 16.875 9C16.875 9.1875 16.8375 9.37187 16.7625 9.55313C16.6875 9.73438 16.5813 9.9 16.4438 10.05L15 11.5125V13.5C15 13.9125 14.8531 14.2656 14.5594 14.5594C14.2656 14.8531 13.9125 15 13.5 15H11.5125L10.05 16.4438C9.9 16.5813 9.73438 16.6875 9.55313 16.7625C9.37187 16.8375 9.1875 16.875 9 16.875C8.8125 16.875 8.62812 16.8375 8.44687 16.7625C8.26562 16.6875 8.1 16.5813 7.95 16.4438L6.4875 15ZM7.125 13.5L9 15.375L10.875 13.5H13.5V10.875L15.375 9L13.5 7.125V4.5H10.875L9 2.625L7.125 4.5H4.5V7.125L2.625 9L4.5 10.875V13.5H7.125Z"
        fill="#114B5B"
      />
    </g>
  </svg>
);

export const FilterIcon = (props: any) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.16665 13.6667C5.93054 13.6667 5.73262 13.5868 5.5729 13.4271C5.41318 13.2674 5.33332 13.0694 5.33332 12.8333V7.83333L0.499986 1.66666C0.291652 1.38888 0.260402 1.09722 0.406236 0.791662C0.552069 0.486106 0.805541 0.333328 1.16665 0.333328H12.8333C13.1944 0.333328 13.4479 0.486106 13.5937 0.791662C13.7396 1.09722 13.7083 1.38888 13.5 1.66666L8.66665 7.83333V12.8333C8.66665 13.0694 8.58679 13.2674 8.42707 13.4271C8.26735 13.5868 8.06943 13.6667 7.83332 13.6667H6.16665ZM6.99999 7.24999L11.125 1.99999H2.87499L6.99999 7.24999Z"
      fill="#302F2E"
      fillOpacity="0.95"
    />
  </svg>
);

export const SortIcon = (props: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3179_7557"
      style={{
        maskType: "alpha"
      }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="20"
      height="20"
    >
      <rect width="20" height="20" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3179_7557)">
      <path
        d="M6.66667 15H3.33333C3.09722 15 2.89931 14.9201 2.73958 14.7604C2.57986 14.6007 2.5 14.4028 2.5 14.1667C2.5 13.9306 2.57986 13.7326 2.73958 13.5729C2.89931 13.4132 3.09722 13.3333 3.33333 13.3333H6.66667C6.90278 13.3333 7.10069 13.4132 7.26042 13.5729C7.42014 13.7326 7.5 13.9306 7.5 14.1667C7.5 14.4028 7.42014 14.6007 7.26042 14.7604C7.10069 14.9201 6.90278 15 6.66667 15ZM16.6667 6.66667H3.33333C3.09722 6.66667 2.89931 6.58681 2.73958 6.42708C2.57986 6.26736 2.5 6.06944 2.5 5.83333C2.5 5.59722 2.57986 5.39931 2.73958 5.23958C2.89931 5.07986 3.09722 5 3.33333 5H16.6667C16.9028 5 17.1007 5.07986 17.2604 5.23958C17.4201 5.39931 17.5 5.59722 17.5 5.83333C17.5 6.06944 17.4201 6.26736 17.2604 6.42708C17.1007 6.58681 16.9028 6.66667 16.6667 6.66667ZM11.6667 10.8333H3.33333C3.09722 10.8333 2.89931 10.7535 2.73958 10.5938C2.57986 10.434 2.5 10.2361 2.5 10C2.5 9.76389 2.57986 9.56597 2.73958 9.40625C2.89931 9.24653 3.09722 9.16667 3.33333 9.16667H11.6667C11.9028 9.16667 12.1007 9.24653 12.2604 9.40625C12.4201 9.56597 12.5 9.76389 12.5 10C12.5 10.2361 12.4201 10.434 12.2604 10.5938C12.1007 10.7535 11.9028 10.8333 11.6667 10.8333Z"
        fill="#302F2E"
        fillOpacity="0.95"
      />
    </g>
  </svg>
);

export const EmptyReportIcon = (props: any) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_3228_697"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="32"
      height="32"
    >
      <rect width="32" height="32" fill="#D9D9D9" />
    </mask>
    <g mask="url(#mask0_3228_697)">
      <path
        d="M9.04798 18.018H14.9583C15.2535 18.018 15.5009 17.9175 15.7006 17.7167C15.9003 17.5159 16.0001 17.267 16.0001 16.9701C16.0001 16.6749 15.9003 16.4275 15.7006 16.2278C15.5009 16.0281 15.2535 15.9283 14.9583 15.9283H9.042C8.74682 15.9283 8.49937 16.0281 8.29967 16.2279C8.09999 16.4276 8.00015 16.675 8.00015 16.9702C8.00015 17.2655 8.10057 17.5139 8.3014 17.7155C8.50223 17.9171 8.75109 18.018 9.04798 18.018ZM9.04798 14.018H14.9583C15.2535 14.018 15.5009 13.9175 15.7006 13.7167C15.9003 13.5159 16.0001 13.267 16.0001 12.9701C16.0001 12.6749 15.9003 12.4275 15.7006 12.2278C15.5009 12.0281 15.2535 11.9283 14.9583 11.9283H9.042C8.74682 11.9283 8.49937 12.0281 8.29967 12.2279C8.09999 12.4276 8.00015 12.675 8.00015 12.9702C8.00015 13.2655 8.10057 13.5139 8.3014 13.7155C8.50223 13.9171 8.75109 14.018 9.04798 14.018ZM6.0719 22.2033C5.44218 22.2033 4.90558 21.9816 4.4621 21.5381C4.01862 21.0946 3.79688 20.558 3.79688 19.9283V4.07178C3.79688 3.44206 4.01862 2.90546 4.4621 2.46198C4.90558 2.01849 5.44218 1.79675 6.0719 1.79675H13.1453C13.4488 1.79675 13.738 1.85373 14.0131 1.96768C14.2882 2.08163 14.5313 2.24422 14.7425 2.45545L19.5447 7.25763C19.756 7.46886 19.9185 7.71201 20.0325 7.98708C20.1465 8.26213 20.2034 8.55141 20.2034 8.85493V19.9283C20.2034 20.558 19.9817 21.0946 19.5382 21.5381C19.0947 21.9816 18.5581 22.2033 17.9284 22.2033H6.0719ZM12.9284 7.93428V4.07178H6.0719V19.9283H17.9284V9.07178H14.0659C13.7467 9.07178 13.4773 8.962 13.2578 8.74243C13.0382 8.52286 12.9284 8.25348 12.9284 7.93428Z"
        fill="#114B5B"
      />
    </g>
  </svg>
);
export const SalesIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <rect width={32} height={32} fill="#F8D1C0" rx={16} />
    <g fill="#752D0D" opacity={0.8}>
      <path d="M17.845 15.467a2.687 2.687 0 0 0-.75-.367 17.49 17.49 0 0 0-.832-.248v-1.83c.247 0 .457.038.614.12.158.075.286.18.383.293.098.12.165.247.21.375.045.135.082.247.105.352h.398c.037-.24.082-.472.12-.705.037-.232.09-.457.15-.69-.18-.09-.353-.165-.495-.232a2.68 2.68 0 0 0-.45-.158 4.642 4.642 0 0 0-.465-.097 5.524 5.524 0 0 0-.563-.045c0-.127 0-.255.008-.375 0-.12.015-.247.03-.367a2.223 2.223 0 0 1-.713 0c.015.134.022.262.022.374v.375c-.322.038-.622.12-.9.24-.277.12-.51.278-.705.466a1.997 1.997 0 0 0-.45.697c-.104.27-.164.578-.164.923 0 .345.045.63.135.877.09.248.202.45.345.615.142.165.3.3.48.398.18.097.36.172.54.232l.697.202V18.7c-.322-.037-.57-.098-.758-.188a1.33 1.33 0 0 1-.434-.314 1.105 1.105 0 0 1-.218-.368 3.373 3.373 0 0 1-.105-.345h-.398c-.037.24-.067.48-.104.72-.038.24-.09.48-.15.72.307.157.63.285.974.383.346.097.743.157 1.193.18 0 .172 0 .337-.008.51 0 .172-.014.337-.022.51.12-.023.24-.03.367-.03.06 0 .12 0 .18.007.06 0 .113.015.166.023-.015-.18-.023-.345-.03-.51 0-.166-.008-.338-.008-.51.728-.068 1.298-.293 1.718-.675.42-.383.63-.953.63-1.718 0-.405-.068-.742-.21-.997a1.9 1.9 0 0 0-.54-.623l.007-.008Zm-2.22-.78c-.06-.022-.135-.044-.232-.082a1.278 1.278 0 0 1-.263-.143.81.81 0 0 1-.218-.232.648.648 0 0 1-.09-.353.77.77 0 0 1 .09-.39.795.795 0 0 1 .225-.247c.09-.06.18-.105.263-.135.09-.03.165-.053.225-.068v1.65Zm1.402 3.563a.8.8 0 0 1-.187.233.921.921 0 0 1-.27.142c-.105.03-.21.067-.323.09v-1.65c.113.037.226.082.33.12.105.038.195.09.278.15.075.06.142.135.18.225.045.09.067.203.067.345a.702.702 0 0 1-.075.352v-.007Z" />
      <path d="M22.75 14.957a6.75 6.75 0 0 0-13.5 0c0 .353.037.698.09 1.043-.053.337-.09.683-.09 1.043a6.75 6.75 0 0 0 13.5 0c0-.353-.038-.698-.09-1.043.052-.338.09-.682.09-1.043ZM16 21.543c-3.315 0-6.06-2.392-6.63-5.542.57-3.15 3.315-5.543 6.63-5.543S22.06 12.85 22.63 16c-.57 3.15-3.315 5.543-6.63 5.543Z" />
    </g>
  </svg>
);
export const CalendarCheckedIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={18}
    height={18}
    fill="none"
    {...props}
  >
    <g opacity={0.45}>
      <mask
        id="a"
        width={18}
        height={18}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha"
        }}
      >
        <path fill="#D9D9D9" d="M0 0h18v18H0z" />
      </mask>
      <g mask="url(#a)">
        <path
          fill="#0D5675"
          d="M7.937 10.193 6.44 8.697a.797.797 0 0 0-.588-.233.797.797 0 0 0-.588.233.79.79 0 0 0-.23.588c0 .236.08.432.235.588l2.065 2.065a.827.827 0 0 0 .602.257c.23 0 .43-.086.6-.257l4.171-4.17a.794.794 0 0 0 .233-.585.794.794 0 0 0-.82-.819.797.797 0 0 0-.588.233l-3.596 3.596ZM9 16.653a7.46 7.46 0 0 1-2.988-.603 7.722 7.722 0 0 1-2.428-1.634 7.723 7.723 0 0 1-1.634-2.428A7.46 7.46 0 0 1 1.348 9c0-1.061.2-2.057.602-2.988.401-.93.946-1.74 1.634-2.428A7.722 7.722 0 0 1 6.012 1.95 7.46 7.46 0 0 1 9 1.348c1.062 0 2.057.2 2.988.602.93.401 1.74.946 2.428 1.634a7.724 7.724 0 0 1 1.634 2.428A7.46 7.46 0 0 1 16.653 9a7.46 7.46 0 0 1-.603 2.988 7.725 7.725 0 0 1-1.634 2.428 7.721 7.721 0 0 1-2.428 1.634A7.46 7.46 0 0 1 9 16.652Zm0-1.707c1.663 0 3.07-.575 4.22-1.726 1.151-1.15 1.726-2.557 1.726-4.22 0-1.663-.575-3.07-1.726-4.22C12.07 3.63 10.663 3.054 9 3.054c-1.663 0-3.07.575-4.22 1.726C3.63 5.93 3.054 7.337 3.054 9c0 1.663.575 3.07 1.726 4.22 1.15 1.15 2.557 1.726 4.22 1.726Z"
        />
      </g>
    </g>
  </svg>
);
export const ArtistSpecifiedIcon = (props: any) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    id="heart"
    width={props?.width || "24"}
    height={props?.height || "24"}
    viewBox="0 0 24 24"
  >
    <path d="M4.56993 7.43C6.38993 5.17 9.27993 5.03 11.2399 7C11.3699 7.13 11.4999 7.28 11.6199 7.43C11.7599 7.6 11.8799 7.78 11.9899 7.97C12.1099 7.79 12.2299 7.6 12.3599 7.43C12.4799 7.28 12.6099 7.13 12.7399 7C14.6999 5.03 17.5799 5.17 19.4099 7.43C20.1099 8.3 20.5599 9.37 20.7499 10.49C21.0999 8.51 21.2299 6.55 19.9799 5C18.0299 2.59 14.2999 2.4 12.3499 4.81C12.2099 4.98 12.0899 5.16 11.9799 5.34C11.8599 5.16 11.7399 4.98 11.6099 4.81C9.65993 2.4 5.92993 2.59 3.97993 5C2.73993 6.54 2.85993 8.5 3.20993 10.49C3.40993 9.37 3.84993 8.3 4.54993 7.43H4.56993Z" />
    <path d="M18.3699 14L11.9999 19L5.62994 14C4.35994 13 3.55994 11.78 3.19994 10.5C2.56994 12.77 3.37994 15.24 5.62994 17L11.9999 22L18.3699 17C20.6199 15.24 21.4199 12.77 20.7999 10.5C20.4499 11.78 19.6399 13 18.3699 14Z" />
  </svg>
);
export const ChoosePlanCheckIcon = (props: any) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M15.4835 4.14551C15.6794 3.85999 16.069 3.78747 16.3545 3.9834C16.6401 4.17933 16.7126 4.56897 16.5167 4.85449L8.9688 15.8545C8.86289 16.0088 8.69334 16.1085 8.50689 16.125C8.32053 16.1415 8.13628 16.0737 8.00494 15.9404L3.55377 11.4219L4.00005 10.9824L4.44634 10.542L8.36431 14.5176L15.4835 4.14551ZM3.55962 10.5352C3.80622 10.2922 4.20328 10.2955 4.44634 10.542L3.55377 11.4219C3.31073 11.1752 3.31297 10.7782 3.55962 10.5352Z"></path>
  </svg>
);
// export const ChoosePlanCheckIcon = (props: any) => (
//   <svg
//     xmlns="http://www.w3.org/2000/svg"
//     width={20}
//     height={20}
//     fill="none"
//     {...props}
//   >
//     <mask
//       id="a"
//       width={20}
//       height={20}
//       x={0}
//       y={0}
//       maskUnits="userSpaceOnUse"
//       style={{
//         maskType: "alpha"
//       }}
//     >
//       <path fill="#D9D9D9" d="M0 0h20v20H0z" />
//     </mask>
//     <g mask="url(#a)">
//       <path
//         fill="#302F2E"
//         fillOpacity={0.38}
//         d="m8.333 11.333 4.917-4.916a.79.79 0 0 1 .583-.23.79.79 0 0 1 .583.23.79.79 0 0 1 .23.583.79.79 0 0 1-.23.583l-5.5 5.5a.8.8 0 0 1-.583.25.8.8 0 0 1-.583-.25l-2.167-2.166a.79.79 0 0 1-.229-.584.79.79 0 0 1 .23-.583.79.79 0 0 1 .583-.23.79.79 0 0 1 .583.23l1.583 1.583Z"
//       />
//     </g>
//   </svg>
// );
